(function ($, d, g) {
    'use strict';

    var lang = d.documentElement.lang;
    var manageTicketsPath = "/action/epManageTickets";
    var managePoolsPath = "/action/epManagePools";
    var managePrivateLinksPath = "/action/epManagePrivateLinks";
    var managePalierPath = "/action/epManagePalier";
    var managePackagePath = "/action/epManagePass";
    var manageMerchPath = "/action/epManageEventProducts";
    var steps = {
        info: 1,
        visual: 2,
        ticket: 3,
        package: 4,
        merch: 5,
        privateLink: 6,
        confirm: 7
    };

    var currPage;
    var eventAgeSelectInput;
    var eventTypeRadioInput;
    var nextStepBtn;
    var oneStepCtn;
    var showStepsRespBtn;
    var createEventForm;
    var createEventBtn;
    var previewEventBtn;
    var publishEventBtn;
    var modifyEventBtn;
    var datePickerInput;
    var timePickerInput;
    var eventVisibilityChoice;
    var eventPublicationChoice;
    var searchProfileInput;
    var searchInputAndDropDownCtn;
    var searchDropDown;
    var searchDropDownChoiceOuterCtn;
    var searchDropDownChoiceInnerCtn;
    var addNewArtistBtn;
    var addNewLocationBtn;
    var profileSelectionBox;
    var addressInput;
    var cityInput;
    var cpInput;
    var provInput;
    var countryInput;
    var toggleSubBtn;
    var toggleServiceFeesBtn;
    var togglePoolingQtyBtn;
    var poolingQtyCtn;
    var poolingQtySelect;
    var serviceFeesCtn;
    var editEventId;

    var displayedProfiles = [];
    var onsave = false;

    var event_recur_type = "";
    var event_start_date = "";
    var event_start_time = "";
    var event_end_date = "";
    var event_end_time = "";
    var event_door_date = "";
    var event_door_time = "";

    var _PASSTICKETS = {};

    var checkAgeChoice = function () {
        var t = $(this);
        var parentCtn = t.closest('.box-theme-content');
        var otherAgeTextInput = parentCtn.find('.admission-age-other-ctn');

        if (t.val() === 'other') {
            otherAgeTextInput.slideDown(300, function () {
                $(this).removeClass('hide');
                $('input[name="admissionOther"]', $(this)).addClass('required');
            });
        } else {
            if (!otherAgeTextInput.hasClass('hide')) {
                otherAgeTextInput.slideUp(300, function () {
                    $(this).addClass('hide');
                    $('input[name="admissionOther"]', $(this)).removeClass('required');
                });
            }
        }
    };

    var checkEventType = function () {
        var t = $(this);
        var oneDayInputs = $('.event-form-one-day-inputs-ctn');
        var multipleDaysInputs = $('.event-form-multiple-days-inputs-ctn');
        var curType = t.val();
        var otherType = "multiple-days";

        if (curType === 'multiple-days') {
            otherType = "one-day";
            oneDayInputs.slideUp(300, function () {
                $(this).addClass('hide');
                $('.event-datetime-start-and-end-ctn input, .event-form-doors-ctn input', $(this)).removeClass('required');
                $('.event-form-doors-ctn .toggle-trigger-element', $(this)).prop('checked', false);
                $('.event-form-doors-ctn .element-to-toggle', $(this)).addClass('hide').removeAttr('style');
                $('.event-form-doors-ctn .element-to-toggle .input-ctn', $(this)).removeClass('focused');
                $('.event-form-doors-ctn .element-to-toggle input', $(this)).val('');

                multipleDaysInputs.slideDown(300, function () {
                    $(this).removeClass('hide');
                    $('.event-datetime-start-and-end-ctn input', $(this)).addClass('required').blur(formValidator.formItemsBlur);
                });
            });
        } else {
            $(".ticket-form-dates-wrap>.ticket-type-multiple-days").appendTo($(".ticket-form-dates-temp"));
            multipleDaysInputs.slideUp(300, function () {
                $(this).addClass('hide');
                $('.event-datetime-start-and-end-ctn input', $(this)).removeClass('required');

                oneDayInputs.slideDown(300, function () {
                    $(this).removeClass('hide');
                    $('.event-datetime-start-and-end-ctn input, .event-form-doors-ctn .timepicker', $(this)).addClass('required').blur(formValidator.formItemsBlur);
                });
            });
        }
        $(".ticket-form-dates-wrap>.ticket-type-" + otherType).appendTo($(".ticket-form-dates-temp"));
        $(".ticket-form-dates-temp>.ticket-type-" + curType).appendTo($(".ticket-form-dates-wrap"));
        $(".ticket-form-ctn.open .close-toggle-form-btn").trigger("click");
    };

    var validateVenue = function (parent) {
        var locationBox = parent.find('.account-box.profile-selection.location');

        if (!locationBox.find('.one-profile-selected-ctn:not(.clone)').length) {
            parent.addClass('error-location').addClass('has-error');
            locationBox.find('input').addClass('error');
            parent.find('.js-form-error-message.error-location').slideDown();
        } else {
            parent.removeClass('error-location');
            parent.find('.js-form-error-message.error-location').slideUp();
        }
    };

    var setEventDateTime = function () {
        event_recur_type = $(".event-form-step-ctn[data-step='1'] .recurring-event-choice-ctn input:checked").val();
        event_start_date = $("#start-date-create-event-" + event_recur_type).val();
        event_start_time = $("#start-time-create-event-" + event_recur_type).val();
        event_end_date = $("#end-date-create-event-" + event_recur_type).val();
        event_end_time = $("#end-time-create-event-" + event_recur_type).val();
        var isOtherDate = $("#create-event-door-other-date").prop("checked");
        event_door_date = isOtherDate ? $("#door-date-create-event-" + event_recur_type).val() : event_start_date;
        event_door_time = $("#door-time-create-event-" + event_recur_type).val();
    };

    var validateMerchDelivery = function () {
        var postal = $('input[name=postalDelivery]');
        var pickup = $('input[name=pickupDelivery]');
        var deliveryChoiceError = $('.js-form-error-message.shipping-check');

        if (!postal.is(':checked') && !pickup.is(':checked') && $('.event-form-products-table tbody').find('tr').length !== 0) {
            postal.closest('.form-checkbox-ctn').addClass('error');
            pickup.closest('.form-checkbox-ctn').addClass('error');
            $('.create-event-form').addClass('error-shipping');
            deliveryChoiceError.slideDown();
        } else {
            postal.closest('.form-checkbox-ctn').removeClass('error');
            pickup.closest('.form-checkbox-ctn').removeClass('error');
            $('.create-event-form').removeClass('error-shipping');
            deliveryChoiceError.slideUp();
        }
    };

    var transiting = false;
    var transtime = 300;

    var changeStep = function (currentStep, chosenStep) {
        var currentStepNumber = $('.steps-bar-one-step-outer-ctn[data-step=' + currentStep + ']'),
                parentBar = currentStepNumber.closest('.steps-bar-outer-ctn').find('.steps-bar-ctn'),
                currentFormStepCtn = $('.event-form-step-ctn[data-step=' + currentStep + ']');

        if (currentStep === steps.info || currentStep === steps.visual || currentStep === steps.ticket || currentStep === steps.merch) {
            if (currentStep === steps.merch) {
                validateMerchDelivery();
                if ($('.create-event-form').hasClass('error-shipping')) {
                    return false;
                }
            }
            if (currentStep === steps.ticket) {
                formValidator.validateForm($('.service-fees-options-ctn'));
            } else {
                formValidator.validateForm(currentFormStepCtn);
            }
        }

        if (currentStep === steps.info) {
            validateVenue(currentFormStepCtn);
        }
        // if not current step and if no errors or is admin
        if (!transiting && currentStep !== chosenStep && !currentFormStepCtn.hasClass('error-location') && (((!currentFormStepCtn.hasClass('has-error') && currentStep !== steps.ticket) || (currentStep === steps.ticket && !$('.service-fees-options-ctn').hasClass('has-error'))) || $('body').hasClass('is-logged-in'))) {
            // Assign event's date and time values
            setEventDateTime();

            var missingStepsErrorMsg = $('.js-form-error-message.form-step.error-msg');
            var chosenFormStepCtn = $('.event-form-step-ctn[data-step=' + chosenStep + ']');

            $('.steps-bar-one-step-outer-ctn.active-responsive').removeClass('active-responsive');
            $('.steps-bar-one-step-outer-ctn[data-step=' + chosenStep + ']').addClass('active-responsive');
            $('.create-event-steps-choice-ctn').slideUp(300);
            showStepsRespBtn.removeClass('open');

            missingStepsErrorMsg.slideUp(300);
            // handle form
            currentFormStepCtn.fadeOut(300, function () {
                currentFormStepCtn.removeClass('active');
                chosenFormStepCtn.fadeIn(300).addClass('active');
                pageScrlTo(0);
            });

            nextStepBtn.attr('data-step', chosenStep);
            publishEventBtn.attr('data-step', chosenStep);

            // handle steps bar
            transiting = true;
            if (chosenStep < currentStep) {
                transtime = 300 / (currentStep - chosenStep);
                parentBar.css("transition-duration", transtime + "ms");
                removeBarProgress(currentStep, chosenStep, parentBar, transtime);
            } else {
                transtime = 300 / (chosenStep - currentStep);
                parentBar.css("transition-duration", transtime + "ms");
                addBarProgress(currentStep, chosenStep, parentBar, transtime);
            }

            // In step 3 we retrieve the capacity in case it has been changed or 
            // new location is added.
            if (chosenStep === steps.ticket && createEventForm.find(".event-room-cap").length) {
                var cap = createEventForm.find(".event-room-cap").val();
                if (cap !== '-1' && cap !== '') {
                    createEventForm.find(".tickets-total-capacity").val(isNaN(cap) ? 0 : cap);
                    checkEventCapacity();
                }
            }

            // Load ticket list in step 4, les forfaits, whenever we go into this step
            // so that all newly created tickets created will be displayed here.
            if (chosenStep === steps.package) {
                loadPackageDirectories(createEventForm.find("[name='id']").val());
            }
            if (chosenStep === steps.privateLink) {
                loadPrivateDirectories(createEventForm.find("[name='id']").val());
            }
        }
    };

    var chooseStep = function (e) {
        var t = $(this);
        var currentStep = t.closest('.create-event-page-wrapper').find('.event-form-step-ctn.active').data('step');
        var chosenStep = t.closest('.steps-bar-one-step-outer-ctn').data('step');

        changeStep(currentStep, chosenStep);
    };

    var goToNextStep = function (e) {
        var t = $(this);
        var currentStep = parseInt(t.attr('data-step'));
        var nextStep = currentStep + 1;

        if (!$('.steps-bar-one-step-outer-ctn[data-step=' + (currentStep + 1) + ']').length) {
            nextStep = currentStep + 2;
        }

        changeStep(currentStep, nextStep);
    };

    var removeBarProgress = function (currentStep, chosenStep, parent, transtime) {
        if (!$('.steps-bar-one-step-outer-ctn[data-step=' + currentStep + ']').length) {
            currentStep = currentStep - 1;
        }

        var stepCtn = $('.steps-bar-one-step-outer-ctn[data-step=' + currentStep + ']', parent);
        var tt = transtime ? transtime : 0;

        stepCtn.addClass('active').removeClass('done');

        if (currentStep !== chosenStep) {
            setTimeout(function () {
                stepCtn.removeClass('active');
                currentStep--;

                if (currentStep >= chosenStep) {
                    setTimeout(function () {
                        removeBarProgress(currentStep, chosenStep, parent, transtime);
                    }, tt * 0.95);
                }
            }, tt * 1.05);
        } else {
            transiting = false;
        }
    };

    var addBarProgress = function (currentStep, chosenStep, parent, transtime) {
        var stepCtn = $('.steps-bar-one-step-outer-ctn[data-step=' + currentStep + ']', parent);
        var nextStep = $('.steps-bar-one-step-outer-ctn[data-step=' + (currentStep + 1) + ']', parent);
        if (!nextStep.length) {
            nextStep = $('.steps-bar-one-step-outer-ctn[data-step=' + (currentStep + 2) + ']', parent);
        }

        var tt = transtime ? transtime : 0;

        if (currentStep !== chosenStep) {
            stepCtn.addClass('done').removeClass('active');

            setTimeout(function () {
                nextStep.addClass('active');
                currentStep++;

                if (currentStep <= chosenStep) {
                    setTimeout(function () {
                        addBarProgress(currentStep, chosenStep, parent, transtime);
                    }, tt * 0.95);
                }
            }, tt * 1.05);
        } else {
            transiting = false;
        }
    };

    var showSteps = function (e) {
        var t = $(this);

        $('.create-event-steps-choice-ctn').slideToggle(300);
        t.toggleClass('open');
    };

    var saveEvent = function (e) {
        $(window).unbind('beforeunload');
        eventPublicationChoice.eq(1).prop(true);
        submitEventForm(true);
    };

    var publishEvent = function (e) {
        $(window).unbind('beforeunload');
        var t = $(this);
        var eventFormStepCtn = $('.event-form-step-ctn');
        var currStepCtn = eventFormStepCtn.filter(".active");

        if (t.hasClass('disabled')) {
            return false;
        }
        t.addClass('disabled');
        formValidator.validateForm(eventFormStepCtn.eq(steps.info - 1));
        formValidator.validateForm(eventFormStepCtn.eq(steps.visual - 1));
        formValidator.validateForm(eventFormStepCtn.eq(steps.confirm - 1));
        if (currStepCtn.hasClass('has-error') || createEventForm.hasClass('has-step-error')) {
            t.removeClass('disabled');
            $(window).bind('beforeunload', function () {
                return true;
            });
        } else {
            $('.js-form-error-message.form-step.error-msg').slideUp(300);
            submitEventForm(true);
        }
    };

    var savePubEvent = function (e) {
        $(window).unbind('beforeunload');
        var t = $(this);
        var currStepCtn = $(".event-form-step-ctn.active");

        if (t.hasClass('disabled')) {
            return false;
        }
        t.addClass('disabled');

        if (currStepCtn.data('step') !== steps.ticket && currStepCtn.data('step') !== steps.package && currStepCtn.data('step') !== steps.privateLink) {
            formValidator.validateForm(currStepCtn);
        }

        if (currStepCtn.hasClass('has-error') || createEventForm.hasClass('has-step-error')) {
            t.removeClass('disabled');
        } else {
            $('.js-form-error-message.form-step.error-msg').slideUp(300);
            submitEventForm(true);
        }
    };
    
    var openEventModifiedPopup = function (e) {
        // Stop publishEvent and savePubEvent functions
        e.stopImmediatePropagation();
        
        var $it = $(e.currentTarget);
        var $popup = $('.event-modified-popup');
        
        // Hide and show respective buttons
        if ($it.hasClass('publish-event-btn')) {
            $popup.find('.modify-event-btn').hide();
            $popup.find('.publish-event-btn').show();
        } else {
            $popup.find('.publish-event-btn').hide();
            $popup.find('.modify-event-btn').show();
        }
        // Open confirmation popup
        $popup.addClass('open');
        $('.parametered-page>.overlay').addClass('active');
    };

    var previewEvent = function (e) {
        createEventForm.find('input[name=preview]').val('true');
        createEventForm.find('.create-event-forward').removeAttr('name');
        createEventForm.find('.preview-event-forward').attr('name', 'pageSuccess');
        createEventForm.attr('target', '_blank');
        submitEventForm(true);

        setTimeout(function () {
            createEventForm.find('input[name=preview]').val('false');
            createEventForm.find('.create-event-forward').attr('name', 'pageSuccess');
            createEventForm.find('.preview-event-forward').removeAttr('name');
            createEventForm.removeAttr('target');
        }, 5);
    };

    var submitEventForm = function (ignore) {
        if (ignore) {
            ignoreInputs($('.event-form-one-day-inputs-ctn.hide'));
            ignoreInputs($('.event-form-multiple-days-inputs-ctn.hide'));
            ignoreInputs($('.clone'));
        }
        createEventForm.submit();
        if (ignore) {
            g.setTimeout(function () {
                cancelIgnoreInputs($('.event-form-one-day-inputs-ctn.hide'));
                cancelIgnoreInputs($('.event-form-multiple-days-inputs-ctn.hide'));
                cancelIgnoreInputs($('.clone'));
            });
        }
    };

    var ignoreInputs = function (ctn) {
        ctn.find('input').each(function () {
            var t = $(this);
            t.attr('data-input-name', t.attr('name'));
            t.attr('name', 'ignore');
        });
    };

    var cancelIgnoreInputs = function (ctn) {
        ctn.find('input').each(function () {
            var t = $(this);
            t.attr('name', t.attr('data-input-name'));
        });
    };

    var getPickerDate = function () {
        var dateSplitVal = $(this).val().split('/');
        var name = $(this).attr('name');
        var parent = $(this).closest('.fake-ctn');

        parent.find('input[name=' + name + 'DateYear]').val(dateSplitVal[0]);
        parent.find('input[name=' + name + 'DateMonth]').val(parseInt(dateSplitVal[1]) - 1);
        parent.find('input[name=' + name + 'DateDay]').val(dateSplitVal[2]);
        
        if(name === 'door'){
            $("#tdib_dt_one-day .tdibv-door-date").text(getDateFormatted(dateSplitVal[0], parseInt(dateSplitVal[1]) - 1, dateSplitVal[2]));
        }
    };

    var getPickerTime = function () {
        var timeSplitVal = $(this).val().split(':');
        var name = $(this).attr('name');
        var parent = $(this).closest('.fake-ctn');

        parent.find('input[name=' + name + 'DateHour]').val(timeSplitVal[0]);
        parent.find('input[name=' + name + 'DateMinute]').val(timeSplitVal[1]);
    };

    var changeDateTimepickerRange = function (dp, input, parentCtn, minDate, isStart) {
        var startDate = $('.start-date.datepicker', parentCtn);
        var endDate = $('.end-date.datepicker', parentCtn);

        if (input.hasClass('datepicker') && input.val() !== '') {
            var chosenDate = input.val();
            var splitChosenDate = chosenDate.split('/');

            if (parentCtn.hasClass('one-day') || input.hasClass("same-date")) {
                if (isStart === true) {
                    var chosenDateObj = new Date(splitChosenDate[0], (splitChosenDate[1] - 1), splitChosenDate[2]);
                    var nextDayDateObj = new Date(chosenDateObj.setDate(chosenDateObj.getDate() + 1));

                    startDate.datetimepicker({
                        startDate: chosenDate,
                        minDate: minDate,
                        maxDate: false
                    });
                    endDate.datetimepicker({
                        startDate: chosenDate,
                        minDate: chosenDate,
                        maxDate: nextDayDateObj
                    });

                    addChosenDate(startDate, chosenDate, 'date');

                    endDate.closest('.event-form-datetime-right').removeClass('disabled');
                    endDate.val('').removeClass('success');
                    endDate.closest('.input-ctn').removeClass('focused').removeClass('error');
                } else {
                    addChosenDate(endDate, chosenDate, 'date');
                }
            } else {
                if (input.hasClass('start-date')) {
                    endDate.datetimepicker({
                        minDate: splitChosenDate[0] + '/' + splitChosenDate[1] + '/' + (parseInt(splitChosenDate[2])),
                        maxDate: false
                    });
                } else if (input.hasClass('end-date')) {
                    startDate.datetimepicker({
                        minDate: false,
                        maxDate: splitChosenDate[0] + '/' + splitChosenDate[1] + '/' + (parseInt(splitChosenDate[2]))
                    });
                }
            }

            compareDates(startDate, endDate, parentCtn);
        }

        if (input.hasClass('timepicker') && input.val() !== '') {
            checkLimitTimeRange(parentCtn, input);
        }
    };

    var compareDates = function (startDate, endDate, parentCtn) {
        if (startDate.val() && endDate.val()) {
            var startDateVal = new Date(startDate.val().split('/')[0], (startDate.val().split('/')[1] - 1), startDate.val().split('/')[2]);
            var endDateVal = new Date(endDate.val().split('/')[0], (endDate.val().split('/')[1] - 1), endDate.val().split('/')[2]);

            if (startDateVal.getTime() === endDateVal.getTime()) {
                parentCtn.addClass('limit-time-range');
                checkLimitTimeRange(parentCtn, null);
            } else {
                parentCtn.removeClass('limit-time-range');
                checkLimitTimeRange(parentCtn, null);
            }
        }
    };

    var checkLimitTimeRange = function (parentCtn, input) {
        var startTime = $('.start-time.timepicker', parentCtn);
        var endTime = $('.end-time.timepicker', parentCtn);

        if (parentCtn.hasClass('limit-time-range')) {
            var chosenTime;

            if (input !== null && input.length) {
                chosenTime = input.val();
            } else if (startTime.val()) {
                chosenTime = startTime.val();
            } else if (endTime.val()) {
                chosenTime = endTime.val();
            } else {
                return;
            }

            var currDate = new Date();
            var timeVal = new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate(), chosenTime.split(':')[0], chosenTime.split(':')[1], '0');

            // on time change
            if (input !== null && input.length) {
                if (input.hasClass('start-time') && chosenTime !== '') {
                    endTime.datetimepicker({
                        minTime: timeVal
                    });
                } else if (input.hasClass('end-time') && chosenTime !== '') {
                    startTime.datetimepicker({
                        maxTime: timeVal
                    });
                }
            } else {
                // on date change
                if (startTime.val()) {
                    if (endTime.val()) {
                        var startTimeVal = new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate(), startTime.val().split(':')[0], startTime.val().split(':')[1], '0');
                        var endTimeVal = new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate(), endTime.val().split(':')[0], endTime.val().split(':')[1], '0');

                        if (endTimeVal < startTimeVal) {
                            endTime.val('').removeClass('success');
                            endTime.closest('.input-ctn').removeClass('focused').removeClass('error');
                        }
                    }
                    endTime.datetimepicker({
                        minTime: timeVal
                    });
                } else if (endTime.val()) {
                    startTime.datetimepicker({
                        maxTime: timeVal
                    });
                }
            }
        } else {
            endTime.datetimepicker({
                minTime: false
            });
            startTime.datetimepicker({
                maxTime: false
            });
        }
    };

    var addChosenDate = function (input, value, type) {
        input.val(value).addClass('success');
        input.closest('.input-ctn').addClass('focused');

        if (type === 'date') {
            input.trigger('change', getPickerDate);
        } else {
            input.trigger('change', getPickerTime);
        }
    };

    var checkVisibilityChoice = function () {
        var t = $(this);
        var parent = t.closest('.box-theme-content');
        var publicDescription = parent.find('.public.event-visibility-description');
        var privateDescription = parent.find('.private.event-visibility-description');

        parent.find('.event-text-description-ctn').slideDown(300, function () {
            if (t.prop('checked') && t.val() === 'on') { // public
                privateDescription.slideUp(300, function () {
                    publicDescription.slideDown(300);
                });
            } else if (t.prop('checked') && t.val() === 'off') { // private
                publicDescription.slideUp(300, function () {
                    privateDescription.slideDown(300);
                });
            }
        });
    };

    var checkPublicationChoice = function () {
        var t = $(this);
        var val = t.val();
        var parent = t.closest('.box-theme-content');
        var publishDescription = parent.find('.publish.event-publication-description');
        var draftDescription = parent.find('.draft.event-publication-description');
        var planificationDescription = parent.find('.planification.event-publication-description');
        var planificationInputsCtn = parent.find('.event-publication-planification-inputs-ctn');

        parent.find('.event-text-description-ctn').slideDown(300);
        publishEventBtn.find(".active").removeClass("active");
        publishEventBtn.find("span").eq(val).addClass("active");
        if (t.prop("checked")) {
            if (val === "0") { //publish
                draftDescription.slideUp(300);
                planificationDescription.slideUp(300);
                planificationInputsCtn.slideUp(300, function () {
                    $('input', $(this)).removeClass('required');
                });
                setTimeout(function () {
                    publishDescription.slideDown(300);
                }, 300);
            } else if (val === "2") { //plan
                publishDescription.slideUp(300);
                draftDescription.slideUp(300);
                setTimeout(function () {
                    planificationDescription.slideDown(300);
                    planificationInputsCtn.slideDown(300, function () {
                        $('input', $(this)).addClass('required');
                    });
                }, 300);
            } else { //draft
                publishDescription.slideUp(300);
                planificationDescription.slideUp(300);
                planificationInputsCtn.slideUp(300, function () {
                    $('input', $(this)).removeClass('required');
                });
                setTimeout(function () {
                    draftDescription.slideDown(300);
                }, 300);
            }
        }
    };

    var searchProfile = function () {
        var t = $(this);
        var type = t.data('misc');
        var searchVal = encodeInputText(t.val());
        var parentCtn = t.closest(searchInputAndDropDownCtn);
        var dropDownDisplayedProfiles = parentCtn.find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item');

        if (searchVal !== '') {
            parentCtn.find(searchDropDown).slideDown(300);
            ajax('/action/epSearchProfiles?type=' + type + '&q=' + searchVal, function (response) {
                var json = JSON.parse(response.trim());
                var newResults = [];

                if (json.length > 0) {
                    $.each(json, function (k, v) {
                        var id = json[k].id;
                        newResults.push(id);

                        if ($.inArray(id, displayedProfiles) === -1) {
                            populateDropDown(parentCtn, json[k], type);
                        }
                    });

                    removeUnrelatedProfilesFromDropDown(parentCtn, displayedProfiles, newResults);
                    displayedProfiles = newResults;


                    parentCtn.find(searchDropDownChoiceOuterCtn).slideDown(300);
                } else {
                    parentCtn.find(searchDropDownChoiceOuterCtn).slideUp(300);
                    emptyDropDown(dropDownDisplayedProfiles);
                }
            }, true);
        } else {
            parentCtn.find(searchDropDown).slideUp(300);
            emptyDropDown(dropDownDisplayedProfiles);
        }
    };

    var emptyDropDown = function (profiles) {
        displayedProfiles = [];
        profiles.slideUp(300, function () {
            $(this).remove();
        });
    };

    var removeUnrelatedProfilesFromDropDown = function (parentCtn, displayedProfiles, newResults) {
        var _remove = function () {
            $(this).remove();
        };
        if (displayedProfiles.length > 0 && newResults.length > 0) {
            for (var i = 0; i < displayedProfiles.length; i++) {
                if ($.inArray(displayedProfiles[i], newResults) === -1) {
                    parentCtn.find('.search-drop-down-one-item#' + displayedProfiles[i]).slideUp(300, _remove);
                }
            }
        }
    };

    var populateDropDown = function (parentCtn, profileObj, type) {
        var id = profileObj.id;
        var name = encodeText(profileObj.field3);
        var email = encodeText(profileObj.field7);
        var friendlyUrl = profileObj.friendlyUrl;
        var imageObj = JSON.parse(profileObj.field5);
        var image = imageObj.profileMediaId.length !== 0 && imageObj.profileMediaId !== '0' ? imageObj.profileMediaId : type;
        var addressObj = JSON.parse(encodeText(profileObj.field6));
        var address = addressObj.address + ', ' + addressObj.city + ', ' + addressObj.province + '  ' + addressObj.postalCode;
        var cap = addressObj.capacity;

        var dropDownItemCtn = parentCtn.find('.search-drop-down-one-item#clone').clone();
        dropDownItemCtn.attr('data-name', name).attr('data-image', image).attr('data-address', address).attr('data-url', friendlyUrl).attr('data-email', email).attr('data-cap', cap);

        styleAndAppendClone(dropDownItemCtn, parentCtn.find(searchDropDownChoiceInnerCtn), id, name, image, address);

        // add listener
        $('.select-profile-from-drop-down#' + id).click(addSelectedProfile);
    };


    var styleAndAppendClone = function (clone, container, id, name, image, address) {
        clone.find('.search-drop-down-one-item-name').html(name);

        if (image !== '') {
            clone.find('.bg-pic').css('background-image', 'url(/static/uploaded/Profile/' + image + '-profile.jpg)');
        }

        if (address !== '') {
            clone.find('.search-drop-down-one-item-location').html(address);
        }

        if (clone.hasClass('search-drop-down-one-item')) {
            clone.attr('id', id);
        } else {
            clone.find('.search-drop-down-one-item').attr('id', id);
        }

        clone.hide().removeClass('clone');
        container.append(clone);
        clone.slideDown(300);
    };

    var addSelectedProfile = function () {
        var t = $(this);
        var type = t.data('type');
        var id = t.attr('id');
        var name = t.data('name');
        var image = t.data('image');
        var address = t.data('address');
        var cap = t.data('cap');
        //var url = t.data('url');
        //var email = t.data('email');
        var parentCtn = t.closest('.box-theme-content');
        var clone = parentCtn.find('.one-profile-selected-ctn.clone.existing-profile').clone();
        //var inputName = clone.data('input-name');
        var selectedProfilesCtn = parentCtn.find('.selected-profiles-ctn');
        var selectedProfileNumber = parseInt(selectedProfilesCtn.find('.one-profile-selected-ctn').length) + 1;
        var isNewProfile = false;

        // check if artist is already in the list of selected artists
        if (type === 0) {
            var prevSelectedArtists = [];

            selectedProfilesCtn.find('.one-profile-selected-ctn').each(function () {
                var t = $(this);
                var prevSeletedArtistId = t.find('.search-drop-down-one-item').attr('id');

                prevSelectedArtists.push(prevSeletedArtistId);
            });

            if ($.inArray(id, prevSelectedArtists) === -1) {
                // if new selection
                clone.attr('data-position', selectedProfileNumber);
                clone.find('input[name=relationId]').val('').attr('name', 'relationId' + selectedProfileNumber);
                clone.find('input[name=artistId]').val(id).attr('name', 'artistId' + selectedProfileNumber);
                isNewProfile = true;
            } else {
                // reset search
                emptyDropDown(parentCtn.find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item'));
                resetSearchProfileInput(parentCtn);
            }
        }

        // location profile
        if (type === 2) {
            $('.tickets-total-capacity').val(cap);
            checkEventCapacity();
            // only one location per event
            parentCtn.find(searchInputAndDropDownCtn).slideUp(300, function () {
                $(this).find('.search-profile-input').removeClass('required');
            });
            clone.find('input[name=locationId]').val(id);
        }

        // listener
        clone.find('.one-profile-selected-remove-btn').click(removeSelectedProfile);

        // displaying selection and resetting search
        if (type !== 0 || type === 0 && isNewProfile === true) {
            styleAndAppendClone(clone, selectedProfilesCtn, id, name, image, address);
            emptyDropDown(parentCtn.find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item'));
            resetSearchProfileInput(parentCtn);
        }
    };

    var removeSelectedProfile = function () {
        var t = $(this);
        var profileToRemove = t.closest('.one-profile-selected-ctn');
        var profileRelationId = profileToRemove.attr('data-relation-id');
        var selectedProfilesCtn = t.closest('.selected-profiles-ctn');
        var type = profileToRemove.find('.search-drop-down-one-item').data('type');
        var parentCtn = t.closest('.box-theme-content');

        if (profileRelationId !== '') {
            if (createEventForm.find('input[name=deleteInvitationIds]').length) {
                var delInvitationIdsInput = createEventForm.find('input[name=deleteInvitationIds]');
                var delInvitationIdsInputVal = delInvitationIdsInput.val() + ',' + profileRelationId;

                delInvitationIdsInput.val(delInvitationIdsInputVal);
            } else {
                createEventForm.append('<input type="hidden" name="deleteInvitationIds" value="' + profileRelationId + '"/>');
            }
        }

        profileToRemove.slideUp(300, function () {
            $(this).remove();

            if (type === 2) {
                parentCtn.find(searchInputAndDropDownCtn).slideDown(300, function () {
                    $(this).find('.search-profile-input').addClass('required');
                });
            }

            // if artist, reassign input numbers
            if (type === 0) {
                var count = 1;

                selectedProfilesCtn.find('.one-profile-selected-ctn').each(function () {
                    var t = $(this);
                    var previousPosition = t.attr('data-position');

                    $(this).find('input[name=artistId' + previousPosition + ']').attr('name', 'artistId' + count);
                    $(this).find('input[name=artistName' + previousPosition + ']').attr('name', 'artistName' + count);
                    $(this).find('input[name=relationId' + previousPosition + ']').attr('name', 'relationId' + count);
                    $(this).find('input[name=artistEmail' + previousPosition + ']').attr('name', 'artistEmail' + count);
                    t.attr('data-position', count);
                    count++;
                });
            }
        });
    };

    var addNewProfile = function () {
        var t = $(this);
        var boxCtn = t.closest('.box-theme-ctn');
        var nameInput = boxCtn.find(searchProfileInput);

        if (nameInput.val() !== '') {
            if (nameInput.attr('name') === 'artistName') {
                addNewArtist(boxCtn, nameInput);
            } else if (nameInput.attr('name') === 'locationName') {
                addNewLocation(boxCtn, nameInput);
            }
        }
    };

    var addNewArtist = function (ctn, nameInput) {
        var clone = ctn.find('.one-profile-selected-ctn.clone.no-profile').clone();
        var selectedProfilesCtn = ctn.find('.selected-profiles-ctn');
        var selectedProfileNumber = parseInt(selectedProfilesCtn.find('.one-profile-selected-ctn').length) + 1;
        var name = nameInput.val();

        clone.attr('data-position', selectedProfileNumber);
        clone.find('input[name=artistName]').attr('name', 'artistName' + selectedProfileNumber).val(name);
        clone.find('input[name=artistEmail]').attr('name', 'artistEmail' + selectedProfileNumber);

        styleAndAppendClone(clone, selectedProfilesCtn, '', name, '', '');
        addSelectedProfileListeners(clone);
        resetSearchProfileInput(ctn);
    };

    var addNewLocation = function (ctn, nameInput) {
        var name = nameInput.val();
        var noAddressClone = ctn.find('.one-profile-selected-ctn.clone.no-profile').clone();
        var form = ctn.find('.event-form-address-ctn');
        var selectedProfilesCtn = ctn.find('.selected-profiles-ctn');

        ctn.find(searchInputAndDropDownCtn).slideUp(300, function () {
            $(this).find('.search-profile-input').removeClass('required');
            resetSearchProfileInput($(this));
            noAddressClone.append('<input type="hidden" name="locationName" value="' + name + '" />');
            styleAndAppendClone(noAddressClone, selectedProfilesCtn, '', name, '', '');
            addSelectedProfileListeners(noAddressClone);
            form.slideDown(300, function () {
                $('input', $(this)).addClass('required');
                profile.activateGlgAutocomplete();
                profile.checkAddress();
                setTimeout(function () {
                    addressInput.removeAttr("placeholder");
                }, 100);
            });
        });
    };

    var saveNewLocation = function (name, ctn, form, selectedProfilesCtn) {
        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            var newLocationDisplay = ctn.find('.one-profile-selected-ctn.no-profile:not(.clone)');
            newLocationDisplay.find('.search-drop-down-one-item-location').html(addressInput.val() + ', ' + cityInput.val() + ', ' + provInput.val() + '  ' + cpInput.val());

            newLocationDisplay.find('.location-datetime-ctn').slideDown(300);
            newLocationDisplay.find('.send-profile-invitation-ctn').slideDown(300);
            newLocationDisplay.find('input[name=locationName]').val(name);

            form.slideUp(300, function () {
                $('input', $(this)).removeClass('required');
            });

            newLocationDisplay.find('.editable-item-btn').click(function () {
                form.slideDown(300, function () {
                    $('input', $(this)).addClass('required');
                });
            });
        }
    };

    var addSelectedProfileListeners = function (ctn) {
        ctn.find('.one-profile-selected-remove-btn').click(removeSelectedProfile);
        var box = ctn.closest('.box-theme-ctn.profile-selection');

        if (box.hasClass('location')) {
            var form = box.find('.event-form-address-ctn');
            var profilesCtn = box.find('.selected-profiles-ctn');

            $('.save-new-location').click(function () {
                saveNewLocation(profilesCtn.find('.search-drop-down-one-item-name').html(), box, box.find('.event-form-address-ctn'), profilesCtn);
            });

            ctn.find('.one-profile-selected-remove-btn').click(function () {
                form.slideUp(150, function () {
                    $(this).find('.input-ctn').each(function () {
                        $(this).removeClass('focused');
                        $(this).find('input').removeClass('success').removeClass('error').val('').removeClass('required');
                    });

                    form.find('#map-ctn').empty().removeAttr('style').removeClass("activated");
                    $('.create-event-form').find('input[name="lat"]').val('');
                    $('.create-event-form').find('input[name="lng"]').val('');

                });

                setTimeout(function () {
                    searchInputAndDropDownCtn.slideDown(300);
                }, 300);
            });

            ctn.find('.editable-item-btn').click(function () {
                form.slideDown(300, function () {
                    $('input', $(this)).addClass('required');
                    profile.activateGlgAutocomplete();
                    profile.checkAddress();
                });
            });
        }

        formAnimate.init();
        ctn.find('.profile-invitation-popup-btn').click(showInvitationPopup);
        ctn.find('.cancel-profile-invitation-btn').click(function () {
            hideInvitationPopup($(this), false);
        });
        ctn.find('.send-profile-invitation-btn').click(function () {
            hideInvitationPopup($(this), true);
        });
    };

    var resetSearchProfileInput = function (container) {
        container.find(searchDropDown).slideUp(300);
        container.find(searchProfileInput).val('');
        container.find('.input-ctn').removeClass('focused');
        container.find('input').removeClass('success').removeClass('error');
    };

    var showInvitationPopup = function () {
        var t = $(this);
        var parentCtn = t.closest('.send-profile-invitation-ctn');
        var relatedPopup = parentCtn.find('.tooltip-ctn.send-profile-invitation');

        if ($('.tooltip-ctn.send-profile-invitation.open').closest('.send-profile-invitation-ctn') !== parentCtn) {
            $('.tooltip-ctn.send-profile-invitation.open').removeClass('open');
        }
        relatedPopup.addClass('open');
    };

    var hideInvitationPopup = function (t, required) {
        var relatedPopup = t.closest('.tooltip-ctn.send-profile-invitation');
        var input = relatedPopup.find('input');
        var emailError = relatedPopup.find('.js-form-error-message.email');

        if (required === true) {
            input.addClass('required');
            formValidator.validateForm(relatedPopup);

            if (relatedPopup.hasClass('has-error')) {
                emailError.slideDown(300, function () {
                    setTimeout(function () {
                        $(this).slideUp(300);
                    }, 5000);
                });
            } else {
                relatedPopup.removeClass('open');
            }
        } else {
            relatedPopup.removeClass('has-error');
            emailError.slideUp(300);
            input.val('');
            input.closest('.input-ctn').removeClass('focused');
            input.removeClass('required').removeClass('error').removeClass('success');

            relatedPopup.removeClass('open');
        }
    };

    var getStatusValue = function (current, start, end, active, stock) {
        if (!active) {
            return -1;
        } else if (current < start) {
            return 0;
        } else if (current <= end && current >= start) {
            return 1;
        } else if (current > end) {
            return 2;
        } else if (stock <= 0) {
            return 3;
        }
    };

    var getStatusText = function (s, d) {
        if (lang === "fr") {
            switch (s.toString()) {
                case "0":
                    return "En vente &agrave; partir du " + "<span class='table-status-timeframe'>" + d[0] + "</span>";
                case "1":
                    return "En vente jusqu'au " + "<span class='table-status-timeframe'>" + d[1] + "</span>";
                case "2":
                    return "Vente termin&eacute;e";
                case "3":
                    return "Quantit&eacute; &eacute;puis&eacute;e";
                default:
                    return "Vente suspendue";
            }
        } else {
            switch (s.toString()) {
                case "0":
                    return "On sale starting from " + "<span class='table-status-timeframe'>" + d[0] + "</span>";
                case "1":
                    return "On sale until " + "<span class='table-status-timeframe'>" + d[1] + "</span>";
                case "2":
                    return "Sale ended";
                case "3":
                    return "Sold out";
                default:
                    return "Sale suspended";
            }
        }
    };

    var getStatusColor = function (s, active) {
        if (!active) {
            return "orange";
        } else {
            switch (s.toString()) {
                case "0":
                    return "yellow";
                case "1":
                    return "blue";
                case "2":
                case "3":
                    return "red";
                default:
                    return "orange";
            }
        }
    };

    var getDateByName = function (ctnq, name, sep) {
        var ctn = $(ctnq);
        return getDateYMD(ctn.find("input[name='" + name + "Year']").val(),
                ctn.find("input[name='" + name + "Month']").val(),
                ctn.find("input[name='" + name + "Day']").val(),
                sep);
    };
    var getTimeByName = function (ctnq, name, sep) {
        var ctn = $(ctnq);
        return getTimeHMS(ctn.find("input[name='" + name + "Hour']").val(),
                ctn.find("input[name='" + name + "Minute']").val(),
                sep);
    };
    var nextDate = function (d, n) {
        try {
            if (n === undefined)
                n = 1;
            var _ = new Date(d);
            var _d = _.getDate() + n;
            if (_d > 31) {
                _d = _.getTime() + (n * 24 * 60 * 60 * 1000);
                _.setTime(_d);
            } else {
                _.setDate(_d);
            }
            return _.getFullYear() + "/" + formatZeros(_.getMonth() + 1) + "/" + formatZeros(_.getDate());
        } catch (ex) {
            return null;
        }
    };
    var nextHour = function (dt, n) {
        try {
            if (n === undefined)
                n = 1;
            var _ = new Date(dt);
            _.setHours(_.getHours() + n);
            return _.getFullYear() + "/" + formatZeros(_.getMonth() + 1) + "/" + formatZeros(_.getDate()) + " " + _.toTimeString();
        } catch (ex) {
            return null;
        }
    };

    var startNewTicket = function (e, p) {
        if (p)
            return;
        if (serviceFeesCtn.length !== 0) {
            toggleServiceFeesBtn.removeClass("active");
            serviceFeesCtn.slideUp();
        }
        var form = $(".ticket-form-ctn"),
                type = $(".event-form-step-ctn[data-step='1'] .recurring-event-choice-ctn input:checked").val(),
                cd = $("#systemCurrentDate").val().replace(/-/g, "/"),
                ct = roundTime($("#systemCurrentTime").val());

        cd = cd.substr(0, 4) + "/" + cd.substr(4, 2) + "/" + cd.substr(6, 2);

        form.find(".create-ticket-btn").text(function () {
            return $(this).attr("data-" + lang + "-label");
        });
        form.find("input, textarea, select").each(function () {
            var $this = $(this),
                    name = $this.attr("name"),
                    type = $this.attr("type");

            if (type === "radio" || type === "checkbox") {
                var checked = $this.prop("checked");
                if (name === "free") {
                    if ($this.val() === "false" && !checked) {
                        $this.trigger("click");
                    }
                } else if(name === "pooling"){
                    $this.prop("checked", false).triggerHandler("click");
                }else {
                    if (checked) {
                        $this.prop("checked", false).triggerHandler("click");
                    }
                }
            } else {
                if (name !== "eventId") {
                    $this.val("");
                    if (type !== "hidden") {
                        $this.removeClass("error success");
                        $this.closest(".input-ctn").removeClass("focused");
                    }
                }
            }
        });
        // Reset pricing
        form.find(".ticket-price-inner-ctn").removeClass("soldisabled").removeAttr("tabIndex").show()
            .find(".ticket-price-input-final, .ticket-price-input-raw").removeClass("disabled").prop("disabled", false)
            .closest(".input-ctn").removeClass("disabled disabled-ctn");
        form.find(".ticket-price-inner-ctn .form-checkbox-ctn").removeClass("disabled disabled-ctn").show()
            .find(".form-check-input").removeClass("disabled").prop("disabled", false);
        // Reset quantities
        $(".ticket-form-info-quantity-sold, .ticket-form-info-quantity-remain", form).text("0");

        if (type === "one-day") {
            var vsdt = nextHour(event_door_date + " " + event_door_time, -1),
                    vedt = nextHour(event_end_date + " " + event_end_time);

            triggerInputFocus("#customStart-date-ticket", event_start_date, "change");
            triggerInputFocus("#customStart-time-ticket", event_start_time, "change");
            triggerInputFocus("#customEnd-date-ticket", event_end_date, "change");
            triggerInputFocus("#customEnd-time-ticket", event_end_time, "change");
            changeTicketDisplayInfoBox($("#tdib_ed_" + type), event_start_date, event_start_time, event_end_time);
            changeTicketDisplayInfoBox($("#tdib_dt_" + type), event_door_date, event_door_time, "");
            $(".display-on-ticket-check").prop("checked", false);
            triggerInputFocus("#customDoorStart-time-ticket", event_door_time, "change");
            triggerInputFocus("#customDoorStart-date-ticket", event_door_date, "change");
            $(".tdib-yes-display").removeClass("hide");
            $(".tdib-no-display").addClass("hide");
            triggerInputFocus("#sellingStart-date-" + type, cd, "change");
            triggerInputFocus("#sellingStart-time-" + type, ct, "change");
            triggerInputFocus("#sellingEnd-date-" + type, event_door_date, "change");
            triggerInputFocus("#sellingEnd-time-" + type, event_door_time, "change");
            triggerInputFocus("#validityStart-date-" + type, vsdt.substring(0, 10), "change");
            triggerInputFocus("#validityStart-time-" + type, vsdt.substring(11, 16), "change");
            triggerInputFocus("#validityEnd-date-" + type, vedt.substring(0, 10), "change");
            triggerInputFocus("#validityEnd-time-" + type, vedt.substring(11, 16), "change");
        } else {
            var inpSMT = $("#customStart-date-" + type),
                    inpEMT = $("#customEnd-date-" + type);

            inpSMT.datetimepicker({
                minDate: event_start_date,
                maxDate: event_end_date,
                onShow: function (ct) {
                    this.setOptions({
                        maxDate: inpEMT.val() !== "" ? inpEMT.val() : event_end_date
                    });
                },
                onChangeDateTime: function (dp, input) {}
            });
            inpEMT.datetimepicker({
                minDate: event_start_date,
                maxDate: event_end_date,
                onShow: function (ct) {
                    this.setOptions({
                        minDate: inpSMT.val() !== "" ? inpSMT.val() : event_start_date
                    });
                },
                onChangeDateTime: function (dp, input) {}
            });

            var _setDefault = function () {
                var tsd = inpSMT.val(),
                        tst = $("#customStart-time-" + type).val(),
                        ted = inpEMT.val(),
                        tet = $("#customEnd-time-" + type).val(),
                        isOtherDate = $("#create-ticket-door-other-date").prop("checked"),
                        doorDate = isOtherDate ? $("#customDoorStart-date-" + type).val() : tsd,
                        doorTime = $(this).val(),
                        vsdt = nextHour(doorDate + " " + doorTime, -1),
                        vedt = nextHour(ted + " " + tet);

                if (tsd === "" || ted === "" || tst === "" || tet === "" || doorDate === "" || doorTime === "") {
                    return false;
                }
                triggerInputFocus("#sellingStart-date-" + type, cd, "change");
                triggerInputFocus("#sellingStart-time-" + type, ct, "change");
                triggerInputFocus("#sellingEnd-date-" + type, doorDate, "change");
                triggerInputFocus("#sellingEnd-time-" + type, doorTime, "change");
                triggerInputFocus("#validityStart-date-" + type, vsdt.substring(0, 10), "change");
                triggerInputFocus("#validityStart-time-" + type, vsdt.substring(11, 16), "change");
                triggerInputFocus("#validityEnd-date-" + type, vedt.substring(0, 10), "change");
                triggerInputFocus("#validityEnd-time-" + type, vedt.substring(11, 16), "change");
                $(this).off("change", _setDefault);
            };
            $("#customDoorStart-time-" + type).on("change", _setDefault);
        }
    };

    var changeTicketDisplayInfoBox = function (ctn, d, ts, te) {
        if (d) {
            var a = d.split("/");
            var df = getDateFormatted(a[0], parseInt(a[1]) - 1, a[2]);
            ctn.find(".tdibv-date").text(df);
        }
        if (ts) {
            ctn.find(".tdibv-time-start").text(getTimeFormatted(ts));
        }
        if (te) {
            ctn.find(".tdibv-time-end").text(getTimeFormatted(te));
        }
    };

    var checkToDisplayEventDT = function () {
        var ctn = $(this).closest(".ticket-form-ctn"),
                names = $(this).val().split(",");

        for (var i = 0; i < names.length; i++) {
            var elS = ctn.find("[name='" + names[i] + "']");
            if ($(this).prop("checked")) {
                elS.addClass("nontake");
            } else {
                elS.removeClass("nontake");
            }
        }
    };

    var modifyTicketDisplayEventDate = function (e) {
        var pu = $(this).closest(".popup");
        var box = $("#tdib_ed_one-day");

        if (pu.find(".display-on-ticket-check").prop("checked")) {
            box.find(".tdib-yes-display").addClass("hide");
            box.find(".tdib-no-display").removeClass("hide");
        } else {
            var date = $("#customStart-date-ticket").val().split("/");
            box.find(".tdibv-date").text(getDateFormatted(date[0], parseInt(date[1]) - 1, date[2]));
            box.find(".tdibv-time-start").text(getTimeFormatted($("#customStart-time-ticket").val()));
            box.find(".tdibv-time-end").text(getTimeFormatted($("#customEnd-time-ticket").val()));
            box.find(".tdib-yes-display").removeClass("hide");
            box.find(".tdib-no-display").addClass("hide");
        }
        pu.find(".popup-inner-close").trigger("click");
    };

    var modifyTicketDisplayDoorTime = function (e) {
        var pu = $(this).closest(".popup");
        var box = $("#tdib_dt_one-day");

        if (pu.find(".display-on-ticket-check").prop("checked")) {
            box.find(".tdib-yes-display").addClass("hide");
            box.find(".tdib-no-display").removeClass("hide");
        } else {
            var date = $("#customDoorStart-date-ticket").val().split("/");
            box.find(".tdibv-date").text(getDateFormatted(date[0], parseInt(date[1]) - 1, date[2]));
            box.find(".tdibv-time-start").text(getTimeFormatted($("#customDoorStart-time-ticket").val()));
            box.find(".tdib-yes-display").removeClass("hide");
            box.find(".tdib-no-display").addClass("hide");
        }
        pu.find(".popup-inner-close").trigger("click");
    };

    var toggleTicketStageForm = function (e) {
        if (serviceFeesCtn.length !== 0) {
            toggleServiceFeesBtn.removeClass("active");
            serviceFeesCtn.slideUp();
        }
        if ($("#palierStart-date-0").val() === "") {
            var cd = $("#systemCurrentDate").val();
            cd = cd.substr(0, 4) + "/" + cd.substr(4, 2) + "/" + cd.substr(6, 2);
            triggerInputFocus("#palierStart-date-0", cd, "change");
        }
        if ($("#palierStart-time-0").val() === "") {
            var ct = roundTime($("#systemCurrentTime").val());
            triggerInputFocus("#palierStart-time-0", ct, "change");
        }
        if ($("#palierEnd-date-0").val() === "") {
            triggerInputFocus("#palierEnd-date-0", event_door_date, "change");
        }
        if ($("#palierEnd-time-0").val() === "") {
            triggerInputFocus("#palierEnd-time-0", event_door_time, "change");
        }
    };

    var togglePriceBox = function (e) {
        var rad = $(this);
        var box = rad.closest(".ticket-price-inner-ctn").find(".tickets-price-box");

        if (rad.prop("checked") && rad.val() === "true" || !rad.prop("checked")) {
            if (!rad.hasClass("toggle-trigger-element"))
                box.slideUp(300);
            box.find(".required").addClass("derequired").removeClass("required error");
        } else {
            if (!rad.hasClass("toggle-trigger-element"))
                box.slideDown(300);
            box.find(".derequired").addClass("required").removeClass("derequired success");
            if ($("input[name = 'passPrice']").length === 0) {
                box.find(".ticket-price-input-raw, .ticket-price-input-fee, .ticket-price-input-final, .ticket-price-input-service-fee").val("");
            }
            box.find(".input-ctn").removeClass('focused');
        }
    };

    var calcTicketPriceRaw = function () {
        var inpTot = $(this),
                ctn = inpTot.closest(".box-content-ticket-price"),
                inpRaw = ctn.find(".ticket-price-input-raw"),
                inpFee = ctn.find(".ticket-price-input-fee"),
                inpServFee = ctn.find(".ticket-price-input-service-fee"),
                originalVal = inpTot.val(),
                val = inpTot.val();
        if (inpServFee.length !== 0 && inpServFee.val() !== 0) {
            val = val - inpServFee.val();
        }

        if (val !== "" && !isNaN(val)) {
            var da = ctn.data(),
                    a = isNaN(da.base) ? 1 : parseFloat(da.base),
                    b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
                    c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
                    min = formatDecimal2(a * c),
                    t = formatDecimal2(Math.max(parseFloat(val), min)),
                    f = formatDecimal2(t - (t - a * c) / (1 + b * c)),
                    p = formatDecimal(t - f),
                    sf = (inpServFee.length !== 0) ? formatDecimal(inpServFee.val()) : formatDecimal(0);

            // Revised EP fee ticket level rounded calculations
            var ep_fee = Math.round((1+(da.percent * p / 100)) * 100) / 100;
            var tax1 = Math.round((da.tax1 * ep_fee) * 100) / 100;
            var tax2 = Math.round((da.tax2 * ep_fee) * 100) / 100;
            f = formatDecimal2(ep_fee + tax1 + tax2);
            t = formatDecimal(p + f + sf);
                    
            inpRaw.val(p.toFixed(2));
            inpFee.val(f.toFixed(2));

            if (inpServFee !== undefined) {
                inpServFee.val(sf.toFixed(2));
            }
            inpTot.val(formatDecimal2(Math.max(parseFloat(originalVal), min)).toFixed(2));
        } else {
            inpRaw.val("");
            inpFee.val("");
            if (inpServFee.length !== 0) {
                inpServFee.val("");
            }
        }
        triggerInputFocus(inpRaw);
        if (inpServFee.length !== 0) {
            triggerInputFocus(inpServFee);
        }
        triggerInputFocus(inpTot);
    };

    var applyPackagePriceFinal = function (e, inp, values) {
        var inpRaw = (inp !== null && inp !== undefined) ? inp : $(this),
                ctn = inpRaw.closest(".box-content-ticket-price"),
                inpTot = ctn.find(".ticket-price-input-final"),
                inpFee = ctn.find(".ticket-price-input-fee");

        if (values === undefined || values.length == 0) {
            inpRaw.val(formatDecimal2(values['price']));
            inpFee.val(formatDecimal2(values['fees']));
            inpTot.val(formatDecimal2(values['total']));
        } 
        triggerInputFocus(inpRaw);
        triggerInputFocus(inpTot);
    };

    var calcTicketPriceFinal = function (e, inp) {
        var inpRaw = (inp !== null && inp !== undefined) ? inp : $(this),
                ctn = inpRaw.closest(".box-content-ticket-price"),
                inpTot = ctn.find(".ticket-price-input-final"),
                inpFee = ctn.find(".ticket-price-input-fee"),
                inpServFee = ctn.find(".ticket-price-input-service-fee"),
                val = inpRaw.val();

        if ($(this).hasClass('ticket-price-input-service-fee')) {
            val = inpServFee.val();
            inpRaw = ctn.find(".ticket-price-input-raw");
        }

        if (val !== "" && !isNaN(val)) {
            var da = ctn.data(),
                    a = isNaN(da.base) ? 1 : parseFloat(da.base),
                    b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
                    c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
                    min = 0,
                    p = !isNaN(inpRaw.val()) && inpRaw.val() !== '' ? formatDecimal2(Math.max(parseFloat(inpRaw.val()), min)) : 0,
                    f = formatDecimal2((a + b * p) * c),
                    sf = inpServFee.length !== 0 && !isNaN(inpServFee.val()) && inpServFee.val() !== '' && parseFloat(inpRaw.val()).toFixed(2) !== '0.00' ? formatDecimal2(parseFloat(inpServFee.val())) : 0,
                    t = formatDecimal(p + f + sf);

            // Revised EP fee ticket level rounded calculations
            var ep_fee = Math.round((1+(da.percent * inpRaw.val() / 100)) * 100) / 100;
            var tax1 = Math.round((da.tax1 * ep_fee) * 100) / 100;
            var tax2 = Math.round((da.tax2 * ep_fee) * 100) / 100;
            f = formatDecimal2(ep_fee + tax1 + tax2);
            t = formatDecimal(p + f + sf);
                    
            inpRaw.val(p.toFixed(2));
            inpFee.val(f.toFixed(2));
            if (inpServFee.length !== 0) {
                inpServFee.val(sf.toFixed(2));
            }
            inpTot.val(t.toFixed(2));
        } else {
            if (!$(this).hasClass('ticket-price-input-service-fee')) {
                inpTot.val("");
                if (inpServFee.length !== 0) {
                    inpServFee.val("");
                }
                inpFee.val("");
            }
        }
        triggerInputFocus(inpRaw);
        if (inpServFee.length !== 0) {
            triggerInputFocus(inpServFee);
        }
        triggerInputFocus(inpTot);
    };

    var checkEventCapacity = function (e) {
        var inp = $(this),
                qty = isNaN(inp.val()) ? 0 : parseInt(inp.val()),
                inpTot = $(".tickets-total-quantity"),
                tot = (isNaN(inpTot.val()) ? -1 : parseInt(inpTot.val())) + qty,
                inpCap = $(".tickets-total-capacity"),
                cap = isNaN(inpCap.val()) ? -1 : parseInt(inpCap.val()),
                inpInv = $(".tickets-total-inventory"),
                inv = isNaN(inpInv.val()) ? 0 : parseInt(inpInv.val()),
                warnBox = $(".tickets-over-capacity");

        if (cap < tot) {
            warnBox.fadeIn(400, function () {
                $(this).removeClass("hide");
            });
        } else {
            warnBox.fadeOut(400, function () {
                $(this).addClass("hide");
            });
        }
        if (!isNaN(qty) && !isNaN(inv)) {
            inp.val(Math.max(qty, inv));
        }
    };

    var updateTicketsTotal = function () {
        var total = 0;
        $(".tickets-list-one-ticket-ctn").each(function () {
            var x = parseInt($(this).attr("data-number"));
            if (!isNaN(x))
                total += x;
        });
        $(".tickets-total-quantity").val(total);
    };

    var createTicket = function (e) {
        var form = $(this).closest(".ticket-form-ctn"),
                inps = form.find("input, textarea, select"),
                fpt = $('.fee-per-transaction-ctn'),
                fptickets = $('.fee-per-ticket-ctn'),
                pooling = $('.pooling-qy-ctn'),
                oData = {},
                data = "";

        formValidator.validateForm(form);


        if (form.hasClass("has-error")) {
            return false;
        }

        if(pooling!== undefined  && pooling.find("input[type='checkbox']").is(":checked") &&  (poolingQtySelect.val()==="" || poolingQtySelect.val()=="-1")){
            alert("Please select pool");
            return false;
        }

        pageScrlTo(form.parent().offset().top - 100);

        inps.each(function () {
            var name = $(this).attr("name");
            if (name && name.trim() !== "") {
                var inp = $(this),
                        type = inp.attr("type"),
                        val = inp.val()!=null?inp.val().trim():"",
                        checkType = type === "checkbox" || type === "radio";

                if ((checkType && inp.prop("checked") || !checkType) && !inp.hasClass("nontake")) {
                    if (inp.hasClass("datepicker")) {
                        name += "Date";
                    } else if (inp.hasClass("timepicker")) {
                        name += "Time";
                    }
                    if (!oData.hasOwnProperty(name))
                        oData[name] = val;
                    data += "&" + name + "=" + encodeURIComponent(val);
                }
            }
        });

        if(pooling!== undefined  ){
            data += "&pooling=" + pooling.find("input[type='checkbox']").is(":checked");
        }
        if (fpt !== undefined && fptickets !== undefined) {
            data += "&feePerTransaction=" + fpt.find("input[type='checkbox']").is(":checked");

            var amount = 0;
            if (fpt.find("input[type='checkbox']").is(":checked")) {
                amount = $(".transaction-service-fee").val();
                if (amount == "") {
                    amount = 0;
                }
            }
            data += "&feePerTransactionAmount=" + amount;
            data += "&feePerTicketCheck=" + fptickets.find("input[type='checkbox']").is(":checked");
        }
        var _fail = function () {
            //Do something;
        };
        var _succeed = function (response) {
            var $tb = $(".event-form-tickets-table>tbody"),
                    pos = $tb.find("tr").length,
                    $tr = $tb.find("tr:eq(0)").clone(true, true),
                    $tdStat = $tr.find(".table-status"),
                    date = new Date(),
                    curDate = date.getFullYear() + "" + (((date.getMonth() + 1) < 10) ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "" + ((date.getDate() < 10) ? "0" + date.getDate() : date.getDate()) + "" + ((date.getHours() < 10) ? "0" + date.getHours() : date.getHours()) + "" + ((date.getMinutes() < 10) ? "0" + date.getMinutes() : date.getMinutes()),
                    sellStartDate = getDateYMD(oData.sellingStartDateYear, oData.sellingStartDateMonth, oData.sellingStartDateDay) + getTimeHMS(oData.sellingStartDateHour, oData.sellingStartDateMinute),
                    sellEndDate = getDateYMD(oData.sellingEndDateYear, oData.sellingEndDateMonth, oData.sellingEndDateDay) + getTimeHMS(oData.sellingEndDateHour, oData.sellingEndDateMinute),
                    dfStart = getDateFormatted(oData.sellingStartDateYear, oData.sellingStartDateMonth, oData.sellingStartDateDay),
                    tfStart = getTimeFormatted(oData.sellingStartDateHour + ":" + oData.sellingStartDateMinute),
                    dfEnd = getDateFormatted(oData.sellingEndDateYear, oData.sellingEndDateMonth, oData.sellingEndDateDay),
                    tfEnd = getTimeFormatted(oData.sellingEndDateHour + ":" + oData.sellingEndDateMinute),
                    fp = oData.free === "true" ? 0 : parseFloat(oData.finalPrice),
                    mf = oData.free === "true" ? (lang === "fr" ? "gratuit" : "free") : formatMoney(fp),
                    stat = 0,
                    active = true,
                    stock = parseInt(oData.qty),
                    service = oData.feePerTicket;
            //Set pooling
            if (pooling !== undefined && pooling.find("input[type='checkbox']").is(":checked")) {
                oData.pooling = pooling.find("input[type='checkbox']").is(":checked") ? "true" : "false";
            } else {
                oData.pooling = "false";
            }
            //Add ticket to the list table
            if (oData.ticketId.toString() === response) {
                $tr = $tb.find("tr[data-tkid='" + oData.ticketId + "']");
                $tdStat = $tr.find(".table-status");
                oData.active = $tr.find(".table-status").attr("data-active");
                active = oData.active === "true";
                stock -= parseInt(oData.inventory);

                if ($(".event-form-packages-table .event-package-ticket-name[data-id = " + oData.ticketId + "]").length !== 0) {
                    $(".event-form-packages-table .event-package-ticket-name[data-id = " + oData.ticketId + "]").text(oData.ticketName);
                }
            } else {
                oData.ticketId = response.trim();
                oData.active = active.toString();
                oData.inventory = 0;
                $tb.append($tr);
                $tr.removeAttr("style").removeAttr("class");
                $tr.attr("data-tkid", oData.ticketId);
                $tr.find(".table-position p").html(pos);
            }

            if ($tb.find('tr:not(.event-form-tickets-row-temp)').length > 0) {
                $('.no-elements-to-display-msg.tickets').fadeOut(function () {
                    $('.event-form-tickets-table').fadeIn();
                });
            }

            $tr.find(".preview-ticket-btn").attr("href", "/action/epTicketsPDF?ticketId=" + oData.ticketId);
            $tr.find(".event-form-ticket-table-name").html(oData.ticketName);
            $tr.find(".event-form-ticket-table-description").html(oData.ticketDescription);
            $tr.find(".table-money p").html(mf);
            $tr.find(".table-money").attr("data-price", fp);
            $tr.find(".table-money").attr("data-service", service);
            stat = getStatusValue(curDate, sellStartDate, sellEndDate, active, stock);

            $tdStat.attr("data-stat", stat).attr("data-active", active)
                    .attr("data-osd", dfStart).attr("data-ost", tfStart)
                    .attr("data-oed", dfEnd).attr("data-oet", tfEnd);
            if (!$tr.hasClass("ticket-is-staged")) {
                $tdStat.attr("data-ssd", dfStart).attr("data-sst", tfStart)
                        .attr("data-sed", dfEnd).attr("data-set", tfEnd);
                $tr.find(".table-status-colorbar").attr("class", function () {
                    return "table-status-colorbar " + $(this).attr("data-sc" + stat);
                });
                $tr.find(".table-status-text").html(function () {
                    var a = [dfStart, dfEnd];
                    var b = "";
                    if (a[stat]) 
                        b = "<span class='table-status-timeframe'>" + a[stat] + "</span>";
                    if (stat==-1) {
                        return $(this).attr("data-st");
                    } else {
                        return $(this).attr("data-st" + stat) + b;
                    }
                });
            }
            $tr.find(".table-quantity p").html(oData.qty + "<span class='table-quantity-left'>(" + stock + ")</span>");
            $tr.find(".xdata").text(JSON.stringify(oData));
            console.log(oData);
            $tr.find("[name='ticketId']").val(oData.ticketId);

            //Add ticket to the staging list (palier)
            var ti = $("#tl1t_" + oData.ticketId);
            if (!ti[0]) {
                ti = $(".ticket-stage-form-ctn .tickets-list-one-ticket-temp").clone(true, true);
                ti.removeClass("tickets-list-one-ticket-temp hide")
                        .attr("id", "tl1t_" + oData.ticketId)
                        .appendTo(".manage-levels-tickets-list-ctn .tickets-list-content-ctn");
            }
            ti.attr("data-name", oData.ticketName)
                    .attr("data-price", oData.finalPrice)
                    .attr("data-number", oData.qty)
                    .attr("data-door", oData.customDoorStartDate + " " + oData.customDoorStartEnd);
            ti.find(".form-check-input").attr("id", "tl1tCb_" + oData.ticketId)
                    .val(oData.ticketId);
            ti.find(".name").text(oData.ticketName);
            ti.find(".price").text(mf);
            ti.find(".date").text(dfStart + ", " + (lang === "fr" ? oData.sellingStartTime.replace(":", "h") : oData.sellingStartTime));

            //Modify existing staged ticket (palier)
            var tir = $("#tl1tr_" + oData.ticketId);
            if (tir[0]) {
                tir.find(".table-ticket-name p").text(oData.ticketName);
                tir.find(".table-quantity p").text(oData.qty);
                tir.find(".table-money p").text(mf);
            }

            //Remove from all pooling 
            $(".event-form-pool-table tr").each(function () {
                $(this).find('.table-tickets-inner p').has('span[data-id="' + oData.ticketId + '"]').remove();
            });

            // Update Pooling if added
            if (pooling !== undefined && pooling.find("input[type='checkbox']").is(":checked")) {
                setTimeout(function () {
                    // Re-select after a delay to ensure new rows are available
                    var matchingRow = $('.event-form-pool-table tr[data-pqid="' + oData.poolId + '"]');
                    if (matchingRow.length) {
                        var newParagraph = $("<p>").append(
                            $("<span>")
                                .addClass("event-pool-ticket-name")
                                .attr("data-id", oData.ticketId)
                                .text(oData.ticketName)
                        );

                        matchingRow.find(".table-tickets-inner").append(newParagraph);
                    }
                }, 0); 
            }

            updateTicketsTotal();
            //Trigger this button will clear all inputs and close the form
            $(".add-new-item-btn.ticket").trigger("click");
        };

        ajax(manageTicketsPath + "?ajax=true" + encodeURI(data), function (response) {
            if (response.trim() == "Having in packages") {
                if (lang === "fr") {
                    alert("Ce billet est inclus dans un forfait. Veuillez le retirer du forfait avant de modifier les prix..!");
                } else {
                    alert("This ticket is included in a package. Please remove the ticket from the package before changing the price..!");
                }
                _fail();
            } else if (response.trim() !== "fail") {
                _succeed(response.trim());
            } else {
                _fail();
            }
        });
    };



    var createPool = function (e) {
        var form = $(this).closest(".pooling-qty-ctn"),
            inps = form.find("input, textarea, select"),
            oData = {},
            data = "";

        formValidator.validateForm(form);
        if (form.hasClass("has-error")) {
            return false;
        }

        pageScrlTo(form.parent().offset().top - 100);

        inps.each(function () {
            var name = $(this).attr("name");
            if (name && name.trim() !== "") {
                var inp = $(this),
                    type = inp.attr("type"),
                    val = inp.val().trim(),
                    checkType = type === "checkbox" || type === "radio";

                if ((checkType && inp.prop("checked") || !checkType) && !inp.hasClass("nontake")) {
                    if (inp.hasClass("datepicker")) {
                        name += "Date";
                    } else if (inp.hasClass("timepicker")) {
                        name += "Time";
                    }
                    if (!oData.hasOwnProperty(name))
                        oData[name] = val;
                    data += "&" + name + "=" + val;
                }
            }
        });
        data += "&active=true"; //+ (oData.active==='true'?'true':'false');

        var _succeed = function (response) {
            var $tb = $(".event-form-pool-table>tbody"),
                pos = $tb.find("tr").length,
                $tr = $tb.find("tr:eq(0)").clone(true, true),
                $tdStat = $tr.find(".table-status"),
                stat = 0,
                active = true,
                poolQty = parseInt(oData.poolQty);
            //Add ticket to the list table
            if (oData.poolId!=null && oData.poolId.toString() === response) {
                $tr = $tb.find("tr[data-pqid='" + oData.poolId + "']");
                $tdStat = $tr.find(".table-status");
                oData.active = $tr.find(".table-status").attr("data-active");
                active = oData.active === "true";
                poolQty -= parseInt(oData.poolQty);
            } else {
                oData.poolId = response.trim();
                oData.active = active.toString();
                $tb.append($tr);
                $tr.removeAttr("style").removeAttr("class");
                $tr.attr("data-pqid", oData.poolId);
            }

            $tr.find(".event-form-pool-table-name").html(oData.poolName);
            $tr.find(".event-form-pool-table-pool-qty").html(oData.poolQty + "(0)");

            $tr.find(".xdata").text(JSON.stringify(oData));
            $tr.find("[name='poolId']").val(oData.poolId);

            //updateTicketsTotal();
            //Trigger this button will clear all inputs and close the form
            $(".manage-pooling-qty").trigger("click");
        };

        ajax(managePoolsPath + "?ajax=true" + encodeURI(data), function (response) {
            if (response.trim().includes("fail")) {
                if(response.trim().includes("changeQtyVialate")){
                    var args=response.trim().split("_");
                    if (lang === "fr") {
                        alert("Des billets sont associés à ce groupe de billets. Vous devez retirer les billets de ce groupe avant de pouvoir le supprimer.");
                    } else {
                        alert("You cannot change the initial quantity than the tickets sold. You have already sold #" +args[1]);
                    }
                }
            } else if (!response.trim().includes("fail")) {
                _succeed(response.trim());
            } else {
                alert(response.trim());
            }
        });
    };









///////----end private link ------////////






    var modifyTicket = function (e) {
        var btn = $(this),
                item = btn.closest("tr");
        var form = $(".ticket-form-ctn"),
                xdata = jsonEscape(item.find(".xdata").eq(0).text()),
                oData = JSON.parse(xdata),
                isFee = $('.fee-per-ticket'),
                isPooling = $('.ticket-pool-qty'),
                poolingEnabled=false;

        pageScrlTo(form.parent().offset().top);

        if (!form.hasClass("open")) {
            $(".add-new-item-btn.ticket").trigger("click", {type: "modify"});
        }
        $(".create-ticket-btn", form).text(function () {
            return $(this).attr("data-" + lang + "-label2");
        });

        // Set event date and time on display to default
        try {
            triggerInputFocus("#customStart-date-ticket", event_start_date, "change");
            triggerInputFocus("#customStart-time-ticket", event_start_time, "change");
            triggerInputFocus("#customEnd-date-ticket", event_end_date, "change");
            triggerInputFocus("#customEnd-time-ticket", event_end_time, "change");
            triggerInputFocus("#customDoorStart-date-ticket", event_door_date, "change");
            triggerInputFocus("#customDoorStart-time-ticket", event_door_time, "change");
        } catch (ex) {
        }

        for (var name in oData) {
            var el = form.find("[name='" + name + "']");
            if (name.substr(name.length - 4) === "Date") {
                el = form.find(".datepicker[name='" + name.substring(0, name.length - 4) + "']");
            } else if (name.substr(name.length - 4) === "Time") {
                el = form.find(".timepicker[name='" + name.substring(0, name.length - 4) + "']");
                oData[name] = oData[name].replace("h", ":");
            }
            if (el.length > 0) {
                var type = el.attr("type");
                var value = oData[name];

                if (type === "radio") {
                    el.each(function () {
                        if ($(this).val() === value) {
                            $(this).prop("checked", true).triggerHandler("change");
                        }
                    });
                } else if (type === "checkbox") {
                    if (name === "pooling") {
                        if (value=="true") {
                            isPooling.prop("checked", true);
                            poolingEnabled=true;
                            isPooling.triggerHandler("click");
                        }else{
                            isPooling.prop("checked", false);
                            poolingEnabled=false;
                            isPooling.triggerHandler("click");
                        }
                       if(parseInt(oData.qtySold) > 0){
                           isPooling.prop("disabled", true);
                           poolingQtySelect.prop("disabled",true);
                       }else{
                           isPooling.prop("disabled", false);
                           poolingQtySelect.prop("disabled",false);
                       }
                    }else{
                        if (el.prop("checked") !== (el.val() === value)) {
                            el.trigger("click").triggerHandler("change");
                        }
                    }
                } else {
                    if (name === "feePerTicket") {
                        if (!isFee.is(":checked")) {
                            value = 0;
                        }
                    }

                    if (name === "poolId") {
                         $(".poolingQtyId").val(value);
                    }

                    if (el[0].tagName === 'TEXTAREA') {
                        value = value.replace(/(?:\\r\\n|\\r|\\n)/g, '\n');
                    }

                    el.val(value);

                    if (type !== "hidden") {
                        el.triggerHandler("blur");
                        triggerInputFocus(el);
                    }
                }
                if (el.closest(".ticket-displayed-info-box-popup-content").length > 0) {
                    el.closest(".ticket-displayed-info-box-popup-content").find(".modify-ticket-display-btn").click();
                }
            }
        }
        calcTicketPriceRaw(e, $(".ticket-price-input-final"));
        
        var esd = event_start_date.replace(/\//g, "-") + "T" + (event_start_time && event_start_time !== "" ? event_start_time + ":00.0" : "00:00:00.0");
        var eed = event_end_date.replace(/\//g, "-") + "T" + (event_end_time && event_end_time !== "" ? event_end_time + ":00.0" : "00:00:00.0");
        var start = new Date(esd);
        var end = new Date(eed);
        var today = new Date();
        // Prevent door price change after the event started or at least 1 ticket has been sold
        var doorPriceCtn = form.find(".ticket-door-price-ctn");
        if (parseInt(oData.qtySold) > 0 || start && start.getTime() < today.getTime()) {
            doorPriceCtn.addClass("soldisabled").attr("tabIndex", "-1");
            if (oData.doorPriceActivated === "true") {
                doorPriceCtn.show();
                doorPriceCtn.find(".ticket-price-door-choice").addClass("disabled").prop("disabled", true)
                    .closest(".form-checkbox-ctn").addClass("disabled disabled-ctn");
                doorPriceCtn.find(".ticket-price-input-final, .ticket-price-input-raw").removeClass("success error").addClass("disabled").prop("disabled", true)
                    .closest(".input-ctn").addClass("disabled disabled-ctn");
            } else {
                doorPriceCtn.hide();
            }
        } else {
            doorPriceCtn.removeClass("soldisabled").removeAttr("tabIndex").show();
            doorPriceCtn.find(".ticket-price-door-choice").removeClass("disabled").prop("disabled", false)
                .closest(".form-checkbox-ctn").removeClass("disabled disabled-ctn");
            doorPriceCtn.find(".ticket-price-input-final, .ticket-price-input-raw").removeClass("disabled").prop("disabled", false)
                .closest(".input-ctn").removeClass("disabled disabled-ctn");
        }
        // Prevent online price change if a ticket was bought or event has ended
        var onlinePriceCtn = form.find(".ticket-online-price-ctn");
        if (parseInt(oData.qtySold) > 0 || parseInt(oData.inventory) > 0 || end && end.getTime() < today.getTime()) {
            onlinePriceCtn.addClass("soldisabled").attr("tabIndex", "-1");
            onlinePriceCtn.find(".ticket-price-input-final, .ticket-price-input-raw").removeClass("success error").addClass("disabled").prop("disabled", true)
                .closest(".input-ctn").addClass("disabled disabled-ctn");
            if (oData.free === "false") {
                onlinePriceCtn.find(".ticket-price-online-choice.pay").addClass("disabled").prop("disabled", true)
                    .closest(".form-checkbox-ctn").addClass("disabled disabled-ctn").show();
                onlinePriceCtn.find(".ticket-price-online-choice.free").addClass("disabled").prop("disabled", true)
                    .closest(".form-checkbox-ctn").addClass("disabled disabled-ctn").hide();
            } else {
                onlinePriceCtn.find(".ticket-price-online-choice.free").addClass("disabled").prop("disabled", true)
                    .closest(".form-checkbox-ctn").addClass("disabled disabled-ctn").show();
                onlinePriceCtn.find(".ticket-price-online-choice.pay").addClass("disabled").prop("disabled", true)
                    .closest(".form-checkbox-ctn").addClass("disabled disabled-ctn").hide();
            }
        } else {
            onlinePriceCtn.removeClass("soldisabled").removeAttr("tabIndex");
            onlinePriceCtn.find(".ticket-price-input-final, .ticket-price-input-raw").removeClass("disabled").prop("disabled", false)
                .closest(".input-ctn").removeClass("disabled disabled-ctn");
            onlinePriceCtn.find(".ticket-price-online-choice").removeClass("disabled").prop("disabled", false)
                .closest(".form-checkbox-ctn").removeClass("disabled disabled-ctn").show();
        }
        
        form.find(".ticket-form-info-quantity-sold").text(oData.inventory);
        if(!poolingEnabled){
            form.find(".ticket-form-info-quantity-remain").text(parseInt(oData.qty) - parseInt(oData.inventory));
        }

        if (oData.customDoorStartDate && oData.customDoorStartDate !== oData.customStartDate) {
            $("#create-ticket-door-other-date").trigger("click");
        }
    };
    var modifyPool = function (e) {
        var btn = $(this),
                item = btn.closest("tr");
        var form = $(".pooling-qty-ctn"),
                xdata = jsonEscape(item.find(".xdata").eq(0).text()),
                oData = JSON.parse(xdata)
               ;

        pageScrlTo(form.parent().offset().top);

        if (!form.hasClass("open")) {
            $(".manage-pooling-qty").trigger("click", {type: "modify"});
        }
        $(".create-pool-btn", form).text(function () {
            return $(this).attr("data-" + lang + "-label2");
        });

        for (var name in oData) {
            var el = form.find("[name='" + name + "']");

            if (el.length > 0) {
                var type = el.attr("type");
                var value = oData[name];

                if (type === "radio") {
                    el.each(function () {
                        if ($(this).val() === value) {
                            $(this).prop("checked", true).triggerHandler("change");
                        }
                    });
                } else if (type === "checkbox") {
                    if (el.prop("checked") !== (el.val() === value)) {
                        el.trigger("click").triggerHandler("change");
                    }
                } else {

                    if (el[0].tagName === 'TEXTAREA') {
                        value = value.replace(/(?:\\r\\n|\\r|\\n)/g, '\n');
                    }

                    el.val(value);

                    if (type !== "hidden") {
                        el.triggerHandler("blur");
                        triggerInputFocus(el);
                    }
                }
            }
        }
    };

    var sortableOptions = function (what) {
        var _updateTickets = function (ui) {
            var $el = ui.item,
                    $list = $el.parent().children(),
                    sel = ".table-position p",
                    cur = parseInt($el.attr("data-index")),
                    pos = $el.index(),
                    s = $list.length - 1;

            $el.removeAttr("data-index");
            if (cur !== pos) {
                ajax(manageTicketsPath + "?ajax=true&ticketId=" + $el.attr("data-tkid") + "&eventId=" + $el.attr("data-evid") + "&targetPosition=" + (pos - 1), function (response) {
                    if (response.trim() !== "fail") {
                        for (var i = 1; i <= s; i++) {
                            var row = $list.eq(i);
                            row.find(sel).html(i);
                        }
                    } else {
                        $el.insertBefore($list.eq(cur < pos ? cur : cur + 1));
                    }
                });
            }
        };
        var _updateTicketStage = function (ui) {
            var $el = ui.item,
                    $list = $el.parent().children(),
                    sel = ".table-position p",
                    cur = parseInt($el.attr("data-index")),
                    pos = $el.index(),
                    s = $list.length - 1;

            $el.removeAttr("data-index");
            if (cur !== pos) {
                for (var i = 1; i <= s; i++) {
                    var row = $list.eq(i);
                    row.find(sel).html(i);
                }
                if (pos === s) {
                    var id = $el.attr("id").split("_")[1];
                    defaultStageEndDate($("#tl1t_" + id).attr("data-door"));
                }
            }
        };

        var _updatePackage = function (ui) {
            var $el = ui.item,
                    $list = $el.parent().children(),
                    sel = ".table-position p",
                    cur = parseInt($el.attr("data-index")),
                    pos = $el.index(),
                    s = $list.length - 1;

            $el.removeAttr("data-index");
            if (cur !== pos) {
                ajax(managePackagePath + "?ajax=true&passId=" + $el.attr("data-pkid") + "&eventId=" + $el.attr("data-evid") + "&targetPosition=" + (pos - 1), function (response) {
                    if (response.trim() !== "fail") {
                        for (var i = 1; i <= s; i++) {
                            var row = $list.eq(i);
                            row.find(sel).html(i);
                        }
                    } else {
                        $el.insertBefore($list.eq(cur < pos ? cur : cur + 1));
                    }
                });
            }
        };
        var _updateMerch = function (ui) {
            var $el = ui.item,
                    $list = $el.parent().children(),
                    sel = ".table-position p",
                    cur = parseInt($el.attr("data-index")),
                    pos = $el.index(),
                    s = $list.length - 1;

            $el.removeAttr("data-index");
            if (cur !== pos) {
                ajax(manageMerchPath + "?ajax=true&linkId=" + $el.attr("data-linkid") + "&productId=" + $el.attr("data-productid") + "&eventId=" + $el.attr("data-evid") + "&targetPosition=" + (pos), function (response) {
                    if (response.trim() !== "fail") {
                        for (var i = 0; i <= s; i++) {
                            var row = $list.eq(i);
                            row.find(sel).html(i + 1);
                        }
                    } else {
                        $el.insertBefore($list.eq(cur < pos ? cur : cur + 1));
                    }
                });
            }
        };
        var o = {
            items: "tr",
            handle: ".table-position-btn",
            helper: function (e, tr)
            {
                var $originals = tr.children();
                var $helper = tr.clone();
                $helper.children().each(function (index)
                {
                    // Set helper cell sizes to match the original sizes
                    $(this).width($originals.eq(index).outerWidth());
                });
                return $helper;
            },
            cancel: "input,textarea,select,option",
            revert: false,
            tolerance: "pointer",
            scrollSensitivity: 60,
            scrollSpeed: 30,
            start: function (e, ui) {
                var $el = ui.item;
                $el.attr("data-index", $el.index());
            },
            stop: function (e, ui) {
                switch (what) {
                    case "ticket":
                        _updateTickets(ui);
                        break;
                    case "stage":
                        _updateTicketStage(ui);
                        break;
                    case "package":
                        _updatePackage(ui);
                        break;
                    case "merch":
                        _updateMerch(ui);
                        break;
                }
            }
        };
        return o;
    };

    var sortItemUp = function (e) {
        var it = $(this),
                el = it.closest("tr"),
                sib = el.prev(),
                cur = el.index();

        var _move = function () {
            el.insertBefore(sib);
            el.find(".table-position p").html(cur - 1);
            sib.find(".table-position p").html(cur);
        };
        var _complete = function (response) {
            if (response.trim() !== "fail")
                _move();
        };

        if (cur > 1) {
            // Deduct 1 extra position as there is 1 template element at index 0
            var targetIndex = cur - 2;
            switch (el.attr("data-type")) {
                case "ticket":
                    ajax(manageTicketsPath + "?ajax=true&ticketId=" + el.attr("data-tkid") + "&eventId=" + el.attr("data-evid") + "&targetPosition=" + targetIndex, _complete);
                    break;
                case "stage":
                    if (el.next().length === 0) {
                        var id = sib.attr("id").split("_")[1];
                        defaultStageEndDate($("#tl1t_" + id).attr("data-door"));
                    }
                    _move();
                    break;
                case "package":
                    ajax(managePackagePath + "?ajax=true&passId=" + el.attr("data-pkid") + "&eventId=" + el.attr("data-evid") + "&targetPosition=" + targetIndex, _complete);
                    break;
            }
        }
    };

    var sortItemDown = function (e) {
        var it = $(this),
                el = it.closest("tr"),
                sib = el.next(),
                cur = el.index();

        var _move = function () {
            sib.insertBefore(el);
            el.find(".table-position p").html(cur + 1);
            sib.find(".table-position p").html(cur);
        };
        var _complete = function (response) {
            if (response.trim() !== "fail")
                _move();
        };

        if (sib.length > 0) {
            // Deduct 1 extra position as there is 1 template element at index 0
            var targetIndex = cur;
            switch (el.attr("data-type")) {
                case "ticket":
                    ajax(manageTicketsPath + "?ajax=true&ticketId=" + el.attr("data-tkid") + "&eventId=" + el.attr("data-evid") + "&targetPosition=" + targetIndex, _complete);
                    break;
                case "stage":
                    _move();
                    if (el.next().length === 0) {
                        var id = el.attr("id").split("_")[1];
                        defaultStageEndDate($("#tl1t_" + id).attr("data-door"));
                    }
                    break;
                case "package":
                    ajax(managePackagePath + "?ajax=true&passId=" + el.attr("data-pkid") + "&eventId=" + el.attr("data-evid") + "&targetPosition=" + targetIndex, _complete);
                    break;
            }
        }
    };

    var confirmDeleteTicket = function (e) {
        var btn = $(this);
        e.stopImmediatePropagation();
        var item = e.data.item,
                evid = item.attr("data-evid"),
                tkid = item.attr("data-tkid");

        ajax(manageTicketsPath + "?ajax=true&eventId=" + evid + "&delete=true&ticketId=" + tkid, function (response) {
            if (response.trim() !== "fail") {
                var table = $('tr[data-tkid=' + tkid + ']').closest('.event-form-tickets-table');
                item.remove();
                if ($("#ticketFormTkId").val() === tkid) {
                    $(".ticket-form-ctn .close-toggle-form-btn").click();
                }
                $("#tl1t_" + tkid).remove();
                $("#tl1tr_" + tkid).remove();
                updateTicketsTotal();
                delete _PASSTICKETS[tkid];

                if (table.find('tbody tr:not(.event-form-tickets-row-temp)').length === 0) {
                    table.fadeOut(function () {
                        $('.no-elements-to-display-msg.tickets').fadeIn();
                    });
                }
            }
        });
        closeWindow("deleteTicketConfirmPopup");
    };

    var deleteTicket = function () {
        var btnDel = $(this),
                data = {item: btnDel.closest("tr")},
                btnYes = $("#deleteTicketConfirmPopup .popup-btn-confirm"),
                btnNo = $("#deleteTicketConfirmPopup .popup-btn-cancel");

        btnYes.one("click", data, confirmDeleteTicket);
        btnNo.one("click", function (e) {
            btnYes.off("click", confirmDeleteTicket);
            closeWindow("deleteTicketConfirmPopup");
        });
        $("#deleteTicketConfirmPopup").css("position", "absolute");
        openWindow("deleteTicketConfirmPopup", true);
    };

    var toggleTicketSale = function () {
        var btn = $(this),
                item = btn.closest("tr"),
                qeid = "&eventId=" + item.data("evid"),
                qtid = "&ticketId=" + item.data("tkid"),
                elCell = item.find(".table-status"),
                elColor = item.find(".table-status-colorbar"),
                elText = item.find(".table-status-text"),
                sus = "suspend-sale-btn",
                act = "activate-sale-btn";

        if (btn.hasClass(sus)) {
            ajax(manageTicketsPath + "?ajax=true&active=false" + qeid + qtid, function (response) {
                if (response.trim() !== "fail") {
                    btn.addClass(act).removeClass(sus);
                    elCell.attr("data-active", "false");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc"));
                    elText.html(elText.attr("data-st"));
                }
            });
        } else if (btn.hasClass(act)) {
            ajax(manageTicketsPath + "?ajax=true&active=true" + qeid + qtid, function (response) {
                if (response.trim() !== "fail") {
                    btn.addClass(sus).removeClass(act);
                    elCell.attr("data-active", "true");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc1"));
                    elText.html(elText.attr("data-st1") + "<span class='table-status-timeframe'>" + elCell.attr("data-sed") + "</span>");
                    var data = {
                        stat: elCell.attr("data-stat"),
                        ssd: elCell.attr("data-ssd"),
                        sed: elCell.attr("data-esd"),
                        dateList: [this.ssd, this.sed],
                        date: ""
                    };
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc" + data.stat));
                    if (data.dateList[data.stat])
                        data.date = "<span class='table-status-timeframe'>" + data.dateList[data.stat] + "</span>";
                    elText.html(elText.attr("data-st" + data.stat) + data.date);
                }
            });
        }
    };

    var setDoorDate = function (e) {
        if (!$(e.data[0]).prop("checked")) {
            $(e.data[1]).val($(this).val()).change()
                    .parent().addClass("focused");
        }
    };

    var defaultStageEndDate = function (datetime) {
        if (event_recur_type === "multiple-days" && $("#stageFormId").val() === "") {
            try {
                var doorDate = new Date(datetime),
                        openTime = new Date(doorDate.setTime(doorDate.getTime() - 60000 * 15));

                triggerInputFocus("#palierEnd-date-0", openTime.getFullYear() + "/" + formatZeros(openTime.getMonth() + 1) + "/" + formatZeros(openTime.getDate()), "change");
                triggerInputFocus("#palierEnd-time-0", openTime.getHours() + ":" + formatZeros(openTime.getMinutes()), "change");
            } catch (err) {
            }
        }
    };

    var addOrRemoveStageTicket = function (e) {
        var cb = $(this),
                remove = !cb.prop("checked"),
                id = cb.val(),
                tb = $(".tickets-stage-table>tbody"),
                tr = remove ? $("#tl1tr_" + id) : $(".tickets-list-trow-temp", tb).clone(true, true);

        if (cb.prop("disabled")) {
            return false;
        }
        if (remove) {
            var pos = parseInt(tr.find(".table-position p").text());

            tr.nextAll("tr").each(function (i) {
                $(this).find(".table-position p").text(pos++);
            });
            tr.remove();
        } else {
            var item = cb.closest(".tickets-list-one-ticket-ctn"),
                    data = item.data(),
                    fp = parseFloat(data.price),
                    mf = 0;

            try {
                mf = fp === 0 ? (lang === "fr" ? "gratuit" : "free") : formatMoney(fp);
            } catch (ex) {
            }
            tr.removeAttr("style").removeAttr("class").attr("id", "tl1tr_" + id);
            tr.find(".table-position p").text(tb.children().length);
            tr.find(".table-ticket-name p").text(data.name);
            tr.find(".table-money p").text(mf);
            tr.find(".table-quantity p").text(data.number);
            tr.appendTo(tb);
            // "La date de fin devrait etre 15 minutes avant l'ouverture des porte 
            // du dernier billets du palier". Recurrent event.
            defaultStageEndDate(data.door);
        }
    };

    var removeStageTicket = function (e) {
        var tr = $(this).closest("tr"),
                id = tr.attr("id").split("_")[1];

        $("#tl1tCb_" + id).click();
    };

    var saveStageTicket = function (e) {
        var form = $(".ticket-stage-form-ctn");

        formValidator.validateForm(form);
        if (form.hasClass("has-error")) {
            return false;
        }

        var eid = $("#ticketFormEvId").val(),
                pid = $("#stageFormId").val(),
                data = "?ajax=true&eventId=" + eid + "&palierId=" + pid,
                oData = {},
                list = "";

        var _complete = function (resp) {
            if (resp !== "fail") {
                if (pid !== "") {
                    $("#stageFormId").val(resp.trim());
                }
                $(".event-form-tickets-table>tbody>tr:gt(0)").each(function () {
                    var tr = $(this),
                            tdStat = tr.find(".table-status"),
                            tdData = getDataSet(tdStat[0]),
                            toChange = tdData.stat != -1 && tdData.stat != 3 && tdData.active,
                            cls = "ticket-is-staged",
                            ctnq = ".ticket-stage-form-ctn",
                            arrRaw = [$("#systemCurrentDate").val() + $("#systemCurrentTime").val().replace(":", "")],
                            arrFormatted = [];

                    if (oData.ticketIds.indexOf(tr.attr("data-tkid")) > -1) {
                        tr.addClass(cls);
                        arrFormatted[0] = getDatePrefix(oData, "palierStart");
                        arrFormatted[1] = getDatePrefix(oData, "palierEnd");
                        arrFormatted[2] = getTimePrefix(oData, "palierStart");
                        arrFormatted[3] = getTimePrefix(oData, "palierEnd");
                        if (toChange) {
                            arrRaw[1] = getDateByName(ctnq, "palierStartDate")
                                    + getTimeByName(ctnq, "palierStartDate");
                            arrRaw[2] = getDateByName(ctnq, "palierEndDate")
                                    + getTimeByName(ctnq, "palierEndDate");
                            tdData.stat = getStatusValue(arrRaw[0], arrRaw[1], arrRaw[2], true, 1);
                            tdStat.attr("data-stat", tdData.stat);
                            tdStat.find(".table-status-text").html(getStatusText(tdData.stat, arrFormatted));
                            tdStat.find(".table-status-colorbar").attr("class", "table-status-colorbar " + getStatusColor(tdData.stat, true));
                        }
                        tdStat.attr("data-ssd", arrFormatted[0])
                                .attr("data-sst", arrFormatted[2])
                                .attr("data-sed", arrFormatted[1])
                                .attr("data-set", arrFormatted[3]);
                    } else if (tr.hasClass(cls)) {
                        tr.removeClass("ticket-is-staged");
                        arrFormatted = [tdData.osd, tdData.oed, tdData.ost, tdData.oet];
                        if (toChange) {
                            arrRaw[1] = parseFormattedDate(arrFormatted[0]) + arrFormatted[2].replace(/[h:]/, "");
                            arrRaw[2] = parseFormattedDate(arrFormatted[1]) + arrFormatted[3].replace(/[h:]/, "");
                            tdData.stat = getStatusValue(arrRaw[0], arrRaw[1], arrRaw[2], true, 1);
                            tdStat.attr("data-stat", tdData.stat);
                            tdStat.find(".table-status-text").html(getStatusText(tdData.stat, arrFormatted));
                            tdStat.find(".table-status-colorbar").attr("class", "table-status-colorbar " + getStatusColor(tdData.stat, true));
                        }
                        tdStat.attr("data-ssd", arrFormatted[0])
                                .attr("data-sst", arrFormatted[2])
                                .attr("data-sed", arrFormatted[1])
                                .attr("data-set", arrFormatted[3]);
                    }
                });
                form.find(".close-toggle-form-btn").click();
            } else {
            }
        };

        $(".ticket-stage-form-ctn .event-datetime-start-and-end-ctn input[type='hidden']").each(function () {
            var inp = $(this);
            data += "&" + inp.attr("name") + "=" + inp.val().trim();
            oData[inp.attr("name")] = inp.val().trim();
        });
        if ($("#stageFormHideInactive").prop("checked")) {
            data += "&hideInactive=on";
            oData.hideInactive = "on";
        }
        oData.ticketIds = ["0"];
        $(".tickets-stage-table>tbody tr").each(function (index) {
            if (index > 0) {
                var id = $(this).attr("id");
                var idn = id.substr(id.indexOf("_") + 1);
                list += (list === "" ? "" : ",") + idn;
                oData.ticketIds[index] = idn;
            }
        });
        data += "&ticketIds=" + list;

        ajax(managePalierPath + encodeURI(data), _complete);
    };

    var showTicketList = function (e) {
        $(this).parent().toggleClass("list-open");
        $(this).next().slideToggle(200);
    };

    var addTicketToPackage = function (e, ctn, source, rebates) {
        var id = $(source).attr("data-id"),
                $target = $(ctn).find(".tickets-list-one-ticket-ctn[data-id='" + id + "']"),
                $folder = $target.closest(".event-folder-single"),
                locked = $(ctn).closest(".soldlocked").length !== 0, // If the package was sold at least 1, its modification is locked
                packageTypeMulti = $(".package-multiple-choice input").is(":checked");
                
        $target.removeClass("hide").addClass("selected");
        if(rebates !== undefined && rebates !== ''){
            $target.find(".package-ticket-rebate input").val(rebates.rebate);
            $target.find(".package-ticket-door-rebate input").val(rebates.doorRebate);
        }
        
        /*Calculate rebates on pass - setup online & door rebate inputs */
        if (!locked) {
            $target.find("input.float-number").keydown(numLockFloat);
            if(packageTypeMulti){
                var reb = $(".tickets-list-one-ticket-ctn.selected input[name = 'rebate'][value != '']").val();
                var rebDoor = $(".tickets-list-one-ticket-ctn.selected input[name = 'doorRebate'][value != '']").val();
                $target.closest(".event-folders-tickets-list").find(".package-ticket-rebate input").val(reb);
                $target.closest(".event-folders-tickets-list").find(".package-ticket-door-rebate input").val(rebDoor);
            }
            $target.find(".package-ticket-rebate input").keyup(calculatePackagePrice);
            $target.find(".package-ticket-door-rebate input").keyup(calculatePackageDoorPrice);
        } else {
            $target.find(".package-ticket-rebate-number-input-ctn").removeClass("focused");
            $target.find("input.float-number").addClass("disabled").prop("disabled", true);
        }
        calculatePackagePrice();
        calculatePackageDoorPrice();
        
        if ($(".ticket-price-door-choice[name = 'passDoorPriceActivated']").is(":checked")) {
            $target.find(".package-ticket-door-rebate").addClass("activated");
        } else {
            $target.find(".package-ticket-door-rebate").removeClass("activated");
        }

        if ($(".ticket-price-online-choice[name = 'passFree']:checked").val() === 'true') {
            $target.find(".package-ticket-rebate").addClass("disabled");
        } else {
            $target.find(".package-ticket-rebate").removeClass("disabled");
        }
        
        $(source).addClass("ui-dropped");
        if (!$folder.hasClass("list-open")) {
            $folder.removeClass("hide");
            showTicketList.apply($folder.find(".tickets-list-header-outer-ctn")[0]);
        }

        if (e === null)
            return;

        // Par d�faut, la date/heure "au" est plac�e au m�me moment que celle du 
        // billet qui a la date de fin de mise en vente la plus tardive, parmi les 
        // billets inclus dans le forfait.
        var inpED = d.getElementById("passEnd-date-4"),
                inpET = d.getElementById("passEnd-time-4"),
                inDate = new Date(inpED.value + " " + inpET.value),
                ed = $(source).attr("data-end"),
                srcDate = new Date(ed);

        if (inDate < srcDate || inpED.value === "") {
            triggerInputFocus(inpED, ed.substring(0, 11), "change");
        }
        if (inDate < srcDate || inpET.value === "") {
            triggerInputFocus(inpET, ed.substring(11), "change");
        }
    };

    var addTicketToPrivateLink = function (e, ctn, source, rebates) {
        var id = $(source).attr("data-id"),
            $target = $(ctn).find(".private-tickets-list-one-ticket-ctn[data-id='" + id + "']"),
            $folder = $target.closest(".private-event-folder-single"),
            locked = $(ctn).closest(".soldlocked").length !== 0, // If the package was sold at least 1, its modification is locked
            packageTypeMulti = $(".package-multiple-choice input").is(":checked");

        $target.removeClass("hide").addClass("selected");
        if(rebates !== undefined && rebates !== ''){
            $target.find(".package-ticket-rebate input").val(rebates.rebate);
            $target.find(".package-ticket-door-rebate input").val(rebates.doorRebate);
        }

        // /*Calculate rebates on pass - setup online & door rebate inputs */
        // if (!locked) {
        //     $target.find("input.float-number").keydown(numLockFloat);
        //     if(packageTypeMulti){
        //         var reb = $(".private-tickets-list-one-ticket-ctn.selected input[name = 'rebate'][value != '']").val();
        //         var rebDoor = $(".private-tickets-list-one-ticket-ctn.selected input[name = 'doorRebate'][value != '']").val();
        //         // $target.closest(".private-event-folders-tickets-list").find(".package-ticket-rebate input").val(reb);
        //         // $target.closest(".private-event-folders-tickets-list").find(".package-ticket-door-rebate input").val(rebDoor);
        //     }
        //     // $target.find(".package-ticket-rebate input").keyup(calculatePackagePrice);
        //     // $target.find(".package-ticket-door-rebate input").keyup(calculatePackageDoorPrice);
        // } else {
        //     $target.find(".package-ticket-rebate-number-input-ctn").removeClass("focused");
        //     $target.find("input.float-number").addClass("disabled").prop("disabled", true);
        // }
        // calculatePackagePrice();
        // calculatePackageDoorPrice();

        // if ($(".ticket-price-door-choice[name = 'passDoorPriceActivated']").is(":checked")) {
        //     $target.find(".package-ticket-door-rebate").addClass("activated");
        // } else {
        //     $target.find(".package-ticket-door-rebate").removeClass("activated");
        // }
        //
        // if ($(".ticket-price-online-choice[name = 'passFree']:checked").val() === 'true') {
        //     $target.find(".package-ticket-rebate").addClass("disabled");
        // } else {
        //     $target.find(".package-ticket-rebate").removeClass("disabled");
        // }

        $(source).addClass("ui-dropped");
        if (!$folder.hasClass("list-open")) {
            $folder.removeClass("hide");
            showTicketList.apply($folder.find(".private-tickets-list-header-outer-ctn")[0]);
        }

        if (e === null)
            return;

        // Par d�faut, la date/heure "au" est plac�e au m�me moment que celle du
        // billet qui a la date de fin de mise en vente la plus tardive, parmi les
        // billets inclus dans le forfait.
        var inpED = d.getElementById("passEnd-date-4"),
            inpET = d.getElementById("passEnd-time-4"),
            inDate = new Date(inpED.value + " " + inpET.value),
            ed = $(source).attr("data-end"),
            srcDate = new Date(ed);

        if (inDate < srcDate || inpED.value === "") {
            triggerInputFocus(inpED, ed.substring(0, 11), "change");
        }
        if (inDate < srcDate || inpET.value === "") {
            triggerInputFocus(inpET, ed.substring(11), "change");
        }
    };


    function updateAllRebateValues(){
        var t = $(this);
        var reb = t.val();
        if (t.closest(".package-ticket-rebate").length !== 0) {
            t.closest(".event-folders-tickets-list").find(".package-ticket-rebate input").val(reb);
            calculatePackagePrice();
        }
        if (t.closest(".package-ticket-door-rebate").length !== 0) {
            t.closest(".event-folders-tickets-list").find(".package-ticket-door-rebate input").val(reb);
            calculatePackageDoorPrice();
        }
    }
    function getMinValue(name){
        var max = [];
        var i = 0;
        $(".tickets-list-one-ticket-ctn.selected input[name = '" + name + "']").each(function(){
            var num;
            if (name=='doorRebate') {
                num = $(this).attr("data-doorprice");
            } else {
                num = $(this).attr("max");
            }
            max[i] = parseFloat(num);
            i++;
        });
        if (max.length === 0) {
            max[0] = -1;
        }
        return Math.min(...max);
    }
    
    function balanceTicketsValues(name, val, max){        
        var finalVal = 0;
        if (val !== undefined) {
            finalVal = max - val;
            if (finalVal < 0) {
                finalVal = 0;
            }
        } else {
            if (name=='doorRebate') {
                finalVal = $(".tickets-list-one-ticket-ctn.selected input[name = " + name + "]").attr("data-doorprice") - $(".tickets-list-one-ticket-ctn.selected input[name = " + name + "]").val();
            } else {
                finalVal = $(".tickets-list-one-ticket-ctn.selected input[name = " + name + "]").attr("max") - $(".tickets-list-one-ticket-ctn.selected input[name = " + name + "]").val();
            }
        }
        var minVal = getMinValue(name);
        if (minVal !== -1 && finalVal > minVal) {
            finalVal = minVal;
        }
        $(".tickets-list-one-ticket-ctn.selected input[name = " + name + "]").each(function () {
            if (name=='doorRebate') {
                $(this).val($(this).attr("data-doorprice") - finalVal);
            } else {
                $(this).val($(this).attr("max") - finalVal);
            }
        });
    }
    //Automatically calculates the raw price by deducting the rebates entered for the online price
    var calculatePackagePrice = function (e){
        var t = $(this);
        var val = t.val(); //rebate applied
        var max = t.attr("max"); //original price
        var packageMulti = $(".package-multiple-choice input").is(":checked");
        if(parseFloat(val) > parseFloat(max)){
            t.val(max);
        }
        if (packageMulti) {
            balanceTicketsValues("rebate", val, max);
        }
        
        var isFree = $(".ticket-price-online-choice").val();
        if(isFree === 'false') {             
            var total = 0;
            var values = [];
            var ctn = $(".tickets-price-online .ticket-price-input-raw").closest(".box-content-ticket-price");
            var inpServFee = ctn.find(".pass-fee-price-inputs-ctn input[name = 'passServiceFee']");
            values['price'] = 0;
            values['fees'] = 0;
            values['service_fee'] = 0;
            values['total'] = 0;
            if(packageMulti){
                let reb = $(".tickets-list-one-ticket-ctn.selected input[name = 'rebate']").val();
                let maxVal = $(".tickets-list-one-ticket-ctn.selected input[name = 'rebate']").attr("max");
                // total = (maxVal - reb) * $(".package-multiple-choice-number input").val();
                let quantity = $(".package-multiple-choice-number input").val();
                let pp = (maxVal - reb);
                let da = ctn.data(),
                a = isNaN(da.base) ? 1 : parseFloat(da.base),
                b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
                c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
                min = 0,
                p = !isNaN(pp) && pp !== '' ? formatDecimal2(Math.max(parseFloat(pp), min)) : 0,
                f = formatDecimal2((a + b * p) * c),
                sf = inpServFee.length !== 0 && !isNaN(inpServFee.val()) && inpServFee.val() !== '' && parseFloat(pp).toFixed(2) !== '0.00' ? formatDecimal2(parseFloat(inpServFee.val())) : 0,
                t = formatDecimal(p + f + sf);
                // Revised EP fee ticket level rounded calculations
                let ep_fee = Math.round((1+(da.percent * pp / 100)) * 100) / 100;
                let tax1 = Math.round((da.tax1 * ep_fee) * 100) / 100;
                let tax2 = Math.round((da.tax2 * ep_fee) * 100) / 100;
                f = formatDecimal2(ep_fee + tax1 + tax2);
                t = formatDecimal(p + f + sf); 
                console.log(f);      
                console.log(quantity);      
                values['price'] = formatDecimal2(p * quantity);
                values['fees'] = formatDecimal2(f * quantity);
                values['service_fee'] = formatDecimal2(sf * quantity);
                values['total'] = formatDecimal2(t * quantity);
                console.log(values); 
            } else {
                $(".tickets-list-one-ticket-ctn.selected input[name = 'rebate']").each(function () {
                    // total += $(this).attr("max") - $(this).val();
                    let pp = $(this).attr("max") - $(this).val();
                    let da = ctn.data(),
                    a = isNaN(da.base) ? 1 : parseFloat(da.base),
                    b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
                    c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
                    min = 0,
                    p = !isNaN(pp) && pp !== '' ? formatDecimal2(Math.max(parseFloat(pp), min)) : 0,
                    f = formatDecimal2((a + b * p) * c),
                    sf = inpServFee.length !== 0 && !isNaN(inpServFee.val()) && inpServFee.val() !== '' && parseFloat(pp).toFixed(2) !== '0.00' ? formatDecimal2(parseFloat(inpServFee.val())) : 0,
                    t = formatDecimal(p + f + sf);
                    // Revised EP fee ticket level rounded calculations
                    let ep_fee = Math.round((1+(da.percent * pp / 100)) * 100) / 100;
                    let tax1 = Math.round((da.tax1 * ep_fee) * 100) / 100;
                    let tax2 = Math.round((da.tax2 * ep_fee) * 100) / 100;
                    f = formatDecimal2(ep_fee + tax1 + tax2);
                    t = formatDecimal(p + f + sf); 
                    console.log(f);      
                    values['price'] += formatDecimal2(p);
                    values['fees'] += formatDecimal2(f);
                    values['service_fee'] += formatDecimal2(sf);
                    values['total'] += formatDecimal2(t);
                    console.log(values);      
                });
            }
            
            $(".tickets-price-online .ticket-price-input-raw").val(total);
            // calcTicketPriceFinal(e, $(".tickets-price-online .ticket-price-input-raw"));
            applyPackagePriceFinal(e, $(".tickets-price-online .ticket-price-input-raw"),values);
        }        
    };
    //Automatically calculates the raw price by deducting the rebates entered for the door price
    var calculatePackageDoorPrice = function (e){
        var t = $(this);
        var val = t.val();
        var max = t.attr("data-doorprice");
        var packageMulti = $(".package-multiple-choice input").is(":checked");
        if(parseInt(val) > parseInt(max)){
            t.val(max);
        }
        if (packageMulti) {
            balanceTicketsValues("doorRebate", val, max);
        }

        var total = 0;
        var values = [];
        var ctn = $(".ticket-price-door-input-raw").closest(".box-content-ticket-price");
        var inpServFee = ctn.find(".pass-fee-price-inputs-ctn input[name = 'passServiceFee']");
        values['price'] = 0;
        values['fees'] = 0;
        values['service_fee'] = 0;
        values['total'] = 0;
        if (packageMulti) {
            var reb = $(".tickets-list-one-ticket-ctn.selected input[name = 'doorRebate']").val();
            var maxVal = $(".tickets-list-one-ticket-ctn.selected input[name = 'doorRebate']").attr("data-doorprice");
            // total = (maxVal - reb) * $(".package-multiple-choice-number input").val();
            let quantity = $(".package-multiple-choice-number input").val();
            let pp = (maxVal - reb);
            let da = ctn.data(),
            a = isNaN(da.base) ? 1 : parseFloat(da.base),
            b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
            c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
            min = 0,
            p = !isNaN(pp) && pp !== '' ? formatDecimal2(Math.max(parseFloat(pp), min)) : 0,
            f = formatDecimal2((a + b * p) * c),
            sf = inpServFee.length !== 0 && !isNaN(inpServFee.val()) && inpServFee.val() !== '' && parseFloat(pp).toFixed(2) !== '0.00' ? formatDecimal2(parseFloat(inpServFee.val())) : 0,
            t = formatDecimal(p + f + sf);
            // Revised EP fee ticket level rounded calculations
            let ep_fee = Math.round((1+(da.percent * pp / 100)) * 100) / 100;
            let tax1 = Math.round((da.tax1 * ep_fee) * 100) / 100;
            let tax2 = Math.round((da.tax2 * ep_fee) * 100) / 100;
            f = formatDecimal2(ep_fee + tax1 + tax2);
            t = formatDecimal(p + f + sf); 
            console.log(f);      
            console.log(quantity);      
            values['price'] = formatDecimal2(p * quantity);
            values['fees'] = formatDecimal2(f * quantity);
            values['service_fee'] = formatDecimal2(sf * quantity);
            values['total'] = formatDecimal2(t * quantity);
            console.log(values); 
        } else {
            $(".tickets-list-one-ticket-ctn.selected input[name = 'doorRebate']").each(function () {
                // total += $(this).attr("max") - $(this).val();
                let pp = $(this).attr("data-doorprice") - $(this).val();
                let da = ctn.data(),
                a = isNaN(da.base) ? 1 : parseFloat(da.base),
                b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
                c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
                min = 0,
                p = !isNaN(pp) && pp !== '' ? formatDecimal2(Math.max(parseFloat(pp), min)) : 0,
                f = formatDecimal2((a + b * p) * c),
                sf = inpServFee.length !== 0 && !isNaN(inpServFee.val()) && inpServFee.val() !== '' && parseFloat(pp).toFixed(2) !== '0.00' ? formatDecimal2(parseFloat(inpServFee.val())) : 0,
                t = formatDecimal(p + f + sf);
                // Revised EP fee ticket level rounded calculations
                let ep_fee = Math.round((1+(da.percent * pp / 100)) * 100) / 100;
                let tax1 = Math.round((da.tax1 * ep_fee) * 100) / 100;
                let tax2 = Math.round((da.tax2 * ep_fee) * 100) / 100;
                f = formatDecimal2(ep_fee + tax1 + tax2);
                t = formatDecimal(p + f + sf); 
                console.log(f);      
                values['price'] += formatDecimal2(p);
                values['fees'] += formatDecimal2(f);
                values['service_fee'] += formatDecimal2(sf);
                values['total'] += formatDecimal2(t);
                console.log(values);     
            });
        }
        $(".ticket-price-door-input-raw").val(total);
        // calcTicketPriceFinal(e, $(".ticket-price-door-input-raw"));   
        applyPackagePriceFinal(e, $(".ticket-price-door-input-raw"),values);
    };
    
    var activatePassRebateTicket = function (e) {
        if($(this).is(":checked")){
            $(".tickets-list-one-ticket-ctn.selected .package-ticket-door-rebate").addClass("activated");
        } else {
            $(".tickets-list-one-ticket-ctn.selected .package-ticket-door-rebate").removeClass("activated");
        }            
    };
    
    var toggleOnlineRebate = function (e) {
        if($(this).val() === 'true'){
            $(".tickets-list-one-ticket-ctn.selected .package-ticket-rebate").addClass("disabled");
        } else {
            $(".tickets-list-one-ticket-ctn.selected .package-ticket-rebate").removeClass("disabled");
            calculatePackagePrice();
        }
            
    };

    var removeTicketFromPackage = function (e) {
        var $item = $(this).closest(".tickets-list-one-ticket-ctn"),
                id = $item.attr("data-id"),
                $source = $(e.data).find(".tickets-list-one-ticket-ctn[data-id='" + id + "']"),
                $folder = $item.closest(".event-folder-single");

        $item.addClass("hide").removeClass("selected");
        $source.removeClass("ui-dropped");
        // If all tickets in this event are not selected, hide the folder
        if ($item.parent().children(".selected").length < 1) {
            $folder.addClass("hide");
            showTicketList.apply($folder.find(".tickets-list-header-outer-ctn")[0]);
        }
    };

    var removeTicketFromPrivateLink = function (e) {
        var $item = $(this).closest(".private-tickets-list-one-ticket-ctn"),
            id = $item.attr("data-id"),
            $source = $(e.data).find(".private-tickets-list-one-ticket-ctn[data-id='" + id + "']"),
            $folder = $item.closest(".private-event-folder-single");

        $item.addClass("hide").removeClass("selected");
        $source.removeClass("ui-dropped");
        // If all tickets in this event are not selected, hide the folder
        if ($item.parent().children(".selected").length < 1) {
            $folder.addClass("hide");
            showTicketList.apply($folder.find(".private-tickets-list-header-outer-ctn")[0]);
        }
    };

    var unloadTickets = function (resource) {
        var res = typeof resource === "string" ? JSON.parse(resource) : resource,
                ctnL = d.querySelector(".left .event-folders-tickets-list"),
                ctnR = d.querySelector(".right .event-folders-tickets-list"),
                temp = d.querySelector(".event-folders-temp>:first-child"),
                tempT = d.querySelector(".event-folders-ticket-temp>:first-child");

        var _selectTicket = function (e) {
            addTicketToPackage(e, ctnR, $(this).closest(".tickets-list-one-ticket-ctn"));
            $(this).closest(".associate-package-tickets-boxes-outer-ctn")[0].scrollLeft = 400;
        };

        // Clear the list to re-add all of the tickets
        ctnL.innerHTML = ctnR.innerHTML = "";
        // Generate all the event folders
        for (var i in res) {
            var o = res[i],
                    clone = temp.cloneNode(true),
                    list = clone.querySelector(".tickets-list-content-ctn");

            if (o.status === "1")
                $(clone).addClass("draft");
                clone.querySelector(".tickets-list-header").innerHTML = o.eventName || createEventForm.find("[name='name']").val();
            if (o.startTime && o.startDate) {
                clone.querySelector(".tickets-list-subheader").innerHTML = o.startTime + ", " + o.startDate;
            } else {
                var eventType = createEventForm.find("[name='ticketType']:checked").val(),
                        eventDate = "",
                        eventHour = "",
                        aEventDate = [];

                if (eventType === "one-day") {
                    eventDate = $("#start-date-create-event-one-day").val();
                    eventHour = getTimeFormatted(createEventForm.find("#start-time-create-event-one-day").val()) + ", ";
                } else {
                    eventDate = $("#start-date-create-event-multiple-days").val();
                }
                aEventDate = eventDate.split(eventDate.match(/-|\//)[0]);
                clone.querySelector(".tickets-list-subheader").innerHTML = eventHour + getDateFormatted(aEventDate[0], aEventDate[1], aEventDate[2]);
            }
            
            var tickets = o.tickets;
            tickets.sort(function (a, b) {
                return a.ticketName.localeCompare(b.ticketName);
            });
            // Generate all of the tickets in the processing event
            for (var j in o.tickets) {
                var oT = o.tickets[j],
                        cloneT = tempT.cloneNode(true);
                
                list.appendChild(cloneT);
                cloneT.querySelector(".name").innerHTML = oT.ticketName;
                cloneT.querySelector(".price").innerHTML = formatMoney(oT.ticketPrice);
//                cloneT.querySelector(".price").innerHTML = formatMoney(oT.ticketFinalPrice);
                cloneT.setAttribute("data-end", oT.sellingEndDate.substring(0, 16).replace(/-/g, "/"));
                cloneT.setAttribute("data-qty", oT.quantity);
                cloneT.setAttribute("data-sold", oT.sold);
                // Add prefix "P1" with ticketId for more uniqueness
                cloneT.setAttribute("data-id", "P1" + oT.ticketId);
                cloneT.setAttribute("data-price", oT.ticketFinalPrice);
                $(cloneT).find("input.float-number").keypress(numLockFloat);
                $(cloneT).find("input.float-number").attr("max", oT.ticketPrice.replace(",","."));
                $(cloneT).find("input.float-number").attr("data-doorprice", oT.ticketDoorPrice.replace(",","."));
                
                if (oT.palier || !oT.active || oT.status === "2" || oT.status === "3") {
                    $(cloneT).addClass("unavailable")
                            .find(".svg-cancel").removeClass("hide");
                } else {
                    $(cloneT).addClass("ui-draggable")
                            .find(".svg-circles").removeClass("hide").addClass("draggable");
                    $(".svg-folder", cloneT).removeClass("hide").click(_selectTicket);
                }
            }
            if (o.tickets.length > 0) {
                // Hide ended and cancelled events
                if (!(o.available && o.available === "true" || o.eventId === editEventId)) {
                    $(clone).addClass("hide");
                }
                // Append event folder clones to left and right box
                ctnL.appendChild(clone);
                // Duplicate hidden list of tickets for the display later
                var clone2 = clone.cloneNode(true);
                ctnR.appendChild(clone2);
                clone.id = "eftll_" + o.eventId;
                // Remove unneccessary handlers in this list
                //*we'll keep the unavailable tickets for the modification of the old bundle
                //$(".unavailable", clone2).remove();
                $(".svg-circles, .svg-folder", clone2).remove();
                $(".svg-cancel", clone2).addClass("hide");
                $(".svg-x", clone2).removeClass("hide")
                        .click(ctnL, removeTicketFromPackage);
                $(".ui-draggable", clone2).addClass("hide");
                $(clone2).addClass("hide");
            }
        }
        // Create accordion action to the folders
        if (!ctnL.hasAttribute("data-ff")) {
            $(ctnL).on("click", ".tickets-list-header-outer-ctn", showTicketList)
                    .attr("data-ff", "");
        }
        if (!ctnR.hasAttribute("data-ff")) {
            $(ctnR).on("click", ".tickets-list-header-outer-ctn", showTicketList)
                    .attr("data-ff", "");
        }
        // Make items in the left block draggable
        $(".ui-draggable", ctnL).draggable({
            handle: ".draggable",
            containment: "document",
            helper: "clone",
            revert: true,
            revertDuration: 200,
            zIndex: 20,
            start: function (e, ui) {
                $(this).addClass("holding");
            },
            stop: function (e, ui) {
                $(this).removeClass("holding");
            }
        });
        // Make the most outer container on the right the drop zone for the tickets
        $(".associate-package-tickets-box.right").droppable({
            accept: ".left .ui-draggable",
            tolerance: "touch",
            activate: function () {
                $(this).addClass("droppable-active");
            },
            deactivate: function () {
                $(this).removeClass("droppable-active droppable-highlight");
            },
            over: function () {
                $(this).addClass("droppable-highlight");
            },
            out: function () {
                $(this).removeClass("droppable-highlight");
            },
            drop: function (e, ui) {
                $(this).removeClass("droppable-active droppable-highlight");
                // Hide revert animation on dragging item helper
                ui.helper.hide();
                addTicketToPackage(e, this, ui.draggable[0]);
            }
        });
    };

    var unloadPrivateTickets = function (resource) {
        var res = typeof resource === "string" ? JSON.parse(resource) : resource,
            ctnL = d.querySelector(".left .private-event-folders-tickets-list"),
            ctnR = d.querySelector(".right .private-event-folders-tickets-list"),
            temp = d.querySelector(".private-event-folders-temp>:first-child"),
            tempT = d.querySelector(".private-event-folders-ticket-temp>:first-child");

        var _selectTicket = function (e) {
            addTicketToPrivateLink(e, ctnR, $(this).closest(".private-tickets-list-one-ticket-ctn"));
            $(this).closest(".associate-private-link-tickets-boxes-outer-ctn")[0].scrollLeft = 400;
        };

        // Clear the list to re-add all of the tickets
        ctnL.innerHTML = ctnR.innerHTML = "";
        // Generate all the event folders
        for (var i in res) {
            var o = res[i],
                clone = temp.cloneNode(true),
                list = clone.querySelector(".private-tickets-list-content-ctn");

            if (o.status === "1")
                $(clone).addClass("draft");
            clone.querySelector(".private-tickets-list-header").innerHTML = o.eventName || createEventForm.find("[name='name']").val();
            if (o.startTime && o.startDate) {
                clone.querySelector(".private-tickets-list-subheader").innerHTML = o.startTime + ", " + o.startDate;
            } else {
                var eventType = createEventForm.find("[name='ticketType']:checked").val(),
                    eventDate = "",
                    eventHour = "",
                    aEventDate = [];

                if (eventType === "one-day") {
                    eventDate = $("#start-date-create-event-one-day").val();
                    eventHour = getTimeFormatted(createEventForm.find("#start-time-create-event-one-day").val()) + ", ";
                } else {
                    eventDate = $("#start-date-create-event-multiple-days").val();
                }
                aEventDate = eventDate.split(eventDate.match(/-|\//)[0]);
                clone.querySelector(".private-tickets-list-subheader").innerHTML = eventHour + getDateFormatted(aEventDate[0], aEventDate[1], aEventDate[2]);
            }

            var tickets = o.tickets;
            tickets.sort(function (a, b) {
                return a.ticketName.localeCompare(b.ticketName);
            });
            // Generate all of the tickets in the processing event
            for (var j in o.tickets) {
                var oT = o.tickets[j],
                    cloneT = tempT.cloneNode(true);

                list.appendChild(cloneT);
                cloneT.querySelector(".name").innerHTML = oT.ticketName;
                cloneT.querySelector(".price").innerHTML = formatMoney(oT.ticketPrice);
//                cloneT.querySelector(".price").innerHTML = formatMoney(oT.ticketFinalPrice);
                cloneT.setAttribute("data-end", oT.sellingEndDate.substring(0, 16).replace(/-/g, "/"));
                cloneT.setAttribute("data-qty", oT.quantity);
                cloneT.setAttribute("data-sold", oT.sold);
                // Add prefix "P1" with ticketId for more uniqueness
                cloneT.setAttribute("data-id", "P1" + oT.ticketId);
                cloneT.setAttribute("data-price", oT.ticketFinalPrice);
                $(cloneT).find("input.float-number").keypress(numLockFloat);
                $(cloneT).find("input.float-number").attr("max", oT.ticketPrice.replace(",","."));

                $(cloneT).addClass("ui-draggable")
                    .find(".svg-circles").removeClass("hide").addClass("draggable");
                $(".svg-folder", cloneT).removeClass("hide").click(_selectTicket);
            }
            if (o.tickets.length > 0) {
                // Hide ended and cancelled events
                // if (!(o.available && o.available === "true" || o.eventId === editEventId)) {
                //     $(clone).addClass("hide");
                // }
                // Append event folder clones to left and right box
                ctnL.appendChild(clone);
                // Duplicate hidden list of tickets for the display later
                var clone2 = clone.cloneNode(true);
                ctnR.appendChild(clone2);
                clone.id = "eftll_" + o.eventId;
                // Remove unneccessary handlers in this list
                //*we'll keep the unavailable tickets for the modification of the old bundle
                //$(".unavailable", clone2).remove();
                $(".svg-circles, .svg-folder", clone2).remove();
                $(".svg-cancel", clone2).addClass("hide");
                $(".svg-x", clone2).removeClass("hide")
                    .click(ctnL, removeTicketFromPrivateLink);
                $(".ui-draggable", clone2).addClass("hide");
                $(clone2).addClass("hide");
            }
        }


        // Create accordion action to the folders
        if (!ctnL.hasAttribute("data-ff")) {
            $(ctnL).on("click", ".private-tickets-list-header-outer-ctn", showTicketList)
                .attr("data-ff", "");
        }


        if (!ctnR.hasAttribute("data-ff")) {
            $(ctnR).on("click", ".private-tickets-list-header-outer-ctn", showTicketList)
                .attr("data-ff", "");
        }

        if (!$(ctnL).hasClass("list-open")) {
            $(ctnL).removeClass("hide");
            showTicketList.apply($(ctnL).find(".private-tickets-list-header-outer-ctn")[0]);
        }
        // Make items in the left block draggable
        $(".ui-draggable", ctnL).draggable({
            handle: ".draggable",
            containment: "document",
            helper: "clone",
            revert: true,
            revertDuration: 200,
            zIndex: 20,
            start: function (e, ui) {
                $(this).addClass("holding");
            },
            stop: function (e, ui) {
                $(this).removeClass("holding");
            }
        });


        $(".associate-private-link-tickets-box.right").droppable({
            accept: ".left .ui-draggable",
            tolerance: "touch",
            activate: function () {
                $(this).addClass("droppable-active");
            },
            deactivate: function () {
                $(this).removeClass("droppable-active droppable-highlight");
            },
            over: function () {
                $(this).addClass("droppable-highlight");
            },
            out: function () {
                $(this).removeClass("droppable-highlight");
            },
            drop: function (e, ui) {
                $(this).removeClass("droppable-active droppable-highlight");
                // Hide revert animation on dragging item helper
                ui.helper.hide();
                addTicketToPrivateLink(e, this, ui.draggable[0]);
            }
        });

      //  $(".private-tickets-list-header-outer-ctn").trigger("click");
    };

    var loadPackageDirectories = function (eventId) {
        ajax(managePackagePath + "?list=true" + (eventId ? "&eventId=" + eventId : ""), function (response) {
            if (response.trim() !== "fail") {
                unloadTickets(response.trim());
            }
        }, true);
    };
    var loadPrivateDirectories = function (eventId) {
        ajax(managePrivateLinksPath + "?list=true" + (eventId ? "&eventId=" + eventId : ""), function (response) {
            if (response.trim() !== "fail") {
                unloadPrivateTickets(response.trim());
            }
        }, true);
    };

    var createPrivateLink = function (e) {
        var form = $(this).closest(".create-private-link-form"),
            inps = form.find("input, textarea, select"),
            inpIds = inps.filter("[name='ticketIds']"),
            ids = [],
            oldIds = [],
            data = "",
            oData = {};
        oData.ticketsHTMList = "";
        $(".private-tickets-list-one-ticket-ctn.selected", form).each(function () {
            // Generate the array of ticket ids and add it to the input.
            // We are doing this before validating the form so that error will be added
            // if this input is required and empty.
            ids.push(this.getAttribute("data-id").replace("P1", ""));

            var id = this.getAttribute("data-id").substring(2);
            oData.ticketsHTMList += "<p><span class='event-private-link-ticket-name' data-id='" + id + "'>" + this.querySelector(".name").innerHTML + "</span> - "
                + $(this).closest(".private-event-folder-single").find(".private-tickets-list-header-text-ctn .private-tickets-list-header").text()
                + "</p>";
        });

        // Before assigning new value to the ticketIds, check if there is an old
        // list of tickets in order to re-enable the checkboxes in the stage group
        // if the number of tickets set in the bundle is 0.
        if (inpIds.val() !== "")
            oldIds = inpIds.val().split(",");
        inpIds.val(ids.join(","));

        inps.each(function () {
            var name = $(this).attr("name");
            if (name && name.trim() !== "") {
                var inp = $(this),
                    type = inp.attr("type"),
                    val = inp.val().trim(),
                    checkType = type === "checkbox" || type === "radio";

                if ((checkType && inp.prop("checked") || !checkType) && !inp.hasClass("nontake")) {
                    if (inp.hasClass("datepicker")) {
                        name += "Date";
                    } else if (inp.hasClass("timepicker")) {
                        name += "Time";
                    }
                    if (!oData.hasOwnProperty(name))
                        oData[name] = val;
                    data += "&" + name + "=" + val;
                }
            }
        });
        if(!(oData.privateLinkId!=null && oData.privateLinkId!=='')){
            oData.active='true';
        }

        data += "&active=" + (oData.active==='true'?'true':'false');

        formValidator.validateForm(form);
        // Validate form if there is any tickets selected
        // if (ids.length === 0)
        //     form.addClass("has-error");


        // Check if this bundle has multiple choice and compare the minimum of tickets
        if (oData.passType === "1") {
            var minTickets = oData.passNbrToChoose - ids.length;
            if (minTickets > 0) {
                form.addClass("has-error");
                alert("Veuillez ajouter " + minTickets + " billets de plus \xE0 votre forfait pour continuer.");
            }
            if (!(oData.passNbrToChoose > 0))
                form.addClass("has-error");
        }

        if (form.hasClass("has-error")) {
            return false;
        }

        var _succeed = function (response) {
            var $tb = $(".event-form-private-link-table>tbody"),
                $tr = $tb.find("tr:eq(0)").clone(true, true),
                rws=$(".event-form-private-link-table>tbody>tr").length-1;
            var fullurl= $(".p_protocol").val()+$(".p_domain").val()+"/"+$(".p_lang").val()+ ($(".p_lang").val()==="fr"?eventLinkFR:eventLinkEN)+$(".p_friendlyUrl").val() +'/' + oData.url;
            if (oData.privateLinkId.toString() === response.trim()) {
                $tr = $tb.find("tr[data-pkid='" + oData.privateLinkId + "']");
              //  $tr.find(".table-private-id").html(oData.privateLinkId);
                $tr.find(".table-private-internal-name").html(oData.internalName);
                $tr.find(".table-private-subtitle").html(oData.subtitle);
                $tr.find(".table-private-url").html(fullurl);
                $tr.find(".table-tickets-inner").html(oData.ticketsHTMList);
                $tr.find(".xdata").text(JSON.stringify(oData));
            } else {
                oData.privateLinkId = response.trim();
                $tb.append($tr);
                $tr.removeAttr("style").removeAttr("class");
                $tr.attr("data-pkid", oData.privateLinkId);
                $tr.attr("data-evid", oData.eventId);
                // $tr.find(".table-private-id").html(rws+1);
                $tr.find(".table-private-internal-name").html(oData.internalName);
                $tr.find(".table-private-subtitle").html(oData.subtitle);
                $tr.find(".table-private-url").html(fullurl);
                $tr.find(".table-tickets-inner").html(oData.ticketsHTMList);
                $tr.find(".table-status-text").html(oData.active==="true"?"Active":"Inactive");
                var ticketIds = oData.ticketIds.split(",");
                // var rebates = oData.name.split(",");
                // var doorRebates = oData.doorRebates.split(",");
                // for (var i = 0; i < ticketIds.length; i++) {
                //     oData["passTicket-" + ticketIds[i]] = {"name" : rebates[i], "description" : doorRebates[i]};
                // };
                $tr.find(".xdata").html(JSON.stringify(oData));
                $tb.append($tr);
            }

            // Trigger this button will clear all inputs and close the form
            $(".add-new-item-btn.private").trigger("click");
            // Refresh list of tickets and event folders
            loadPrivateDirectories();
        };
        pageScrlTo(form.parent().offset().top - 100);
        ajax(managePrivateLinksPath + "?ajax=true" + encodeURI(data), function (response) {
            if (!response.trim().includes("fail")) {
                _succeed(response.trim());
            } else {
               var errors= response.trim().split("-");
               alert(errors[1]);
            }
        });
    };

    var createPackage = function (e) {
        var form = $(this).closest(".create-package-form"),
                inps = form.find("input, textarea, select"),
                inpIds = inps.filter("[name='ticketIds']"),
                inpRebates = inps.filter("[name='rebates']"),
                inpDoorRebates = inps.filter("[name='doorRebates']"),
                ids = [],
                rebates = [],
                doorRebates = [],
                oldIds = [],
                data = "",
                oData = {};

        oData.ticketsQty = 0;
        oData.ticketsSold = 0;
        oData.ticketsSoldOut = false;
        oData.ticketsHTMList = "";
        $(".tickets-list-one-ticket-ctn.selected", form).each(function () {
            // Generate the array of ticket ids and add it to the input.
            // We are doing this before validating the form so that error will be added
            // if this input is required and empty.
            ids.push(this.getAttribute("data-id").replace("P1", ""));
            var rebate = $(this).find(".package-ticket-rebate input").val();
            rebates.push(rebate === '' ? 0 : rebate);
            var doorRebate = $(this).find(".package-ticket-door-rebate input").val();
            doorRebates.push(doorRebate === '' ? 0 : doorRebate);
            // Calculate the total ticket quantities and inventories.
            oData.ticketsQty += parseInt(this.getAttribute("data-qty"));
            oData.ticketsSold += parseInt(this.getAttribute("data-sold"));
            if (parseInt(this.getAttribute("data-qty")) <= parseInt(this.getAttribute("data-sold"))) {
                oData.ticketsSoldOut = true;
            }
            var id = this.getAttribute("data-id").substring(2);
            oData.ticketsHTMList += "<p><span class='event-package-ticket-name' data-id='" + id + "'>" + this.querySelector(".name").innerHTML + "</span> - "
                    + $(this).closest(".event-folder-single").find(".tickets-list-header-text-ctn .tickets-list-header").text()
                    + "</p>";
        });
        // Before assigning new value to the ticketIds, check if there is an old
        // list of tickets in order to re-enable the checkboxes in the stage group
        // if the number of tickets set in the bundle is 0.
        if (inpIds.val() !== "")
            oldIds = inpIds.val().split(",");
        inpIds.val(ids.join(","));
        
        inpRebates.val(rebates.join(","));
        inpDoorRebates.val(doorRebates.join(","));

        formValidator.validateForm(form);
        // Validate form if there is any tickets selected
        if (ids.length === 0)
            form.addClass("has-error");

        inps.each(function () {
            var name = $(this).attr("name");
            if (name && name.trim() !== "") {
                var inp = $(this),
                        type = inp.attr("type"),
                        val = inp.val().trim(),
                        checkType = type === "checkbox" || type === "radio";

                if ((checkType && inp.prop("checked") || !checkType) && !inp.hasClass("nontake")) {
                    if (inp.hasClass("datepicker")) {
                        name += "Date";
                    } else if (inp.hasClass("timepicker")) {
                        name += "Time";
                    }
                    if (!oData.hasOwnProperty(name))
                        oData[name] = val;
                    data += "&" + name + "=" + val;
                }
            }
        });
        // Check if this bundle has multiple choice and compare the minimum of tickets
        if (oData.passType === "1") {
            var minTickets = oData.passNbrToChoose - ids.length;
            if (minTickets > 0) {
                form.addClass("has-error");
                alert("Veuillez ajouter " + minTickets + " billets de plus \xE0 votre forfait pour continuer.");
            }
            if (!(oData.passNbrToChoose > 0))
                form.addClass("has-error");
        }

        if (form.hasClass("has-error")) {
            return false;
        }

        var _succeed = function (response) {
            var $tb = $(".event-form-packages-table>tbody"),
                    pos = $tb.find("tr").length,
                    $tr = $tb.find("tr:eq(0)").clone(true, true),
                    date = new Date(),
//                curDate = $("#systemCurrentDate").val(),                
                    curDate = date.getFullYear() + "" + (((date.getMonth() + 1) < 10) ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "" + ((date.getDate() < 10) ? "0" + date.getDate() : date.getDate()),
                    sellEndDate = getDateYMD(oData.passEndDateYear, oData.passEndDateMonth, oData.passEndDateDay),
                    fp = oData.passFree === "true" ? 0 : parseFloat(oData.passFinalPrice),
                    mf = oData.passFree === "true" ? (lang === "fr" ? "gratuit" : "free") : formatMoney(fp),
                    stat = 0,
                    active = true,
                    stock = parseInt(oData.qty),
                    hasEventTicket = false;

            // There are new added tickets, increase their counts
            for (var ind in ids) {
                if (oldIds.indexOf(ind) === -1) {
                    if (_PASSTICKETS[ind]) {
                        _PASSTICKETS[ind]++;
                    } else {
                        _PASSTICKETS[ind] = 1;
                    }
                }
            }
            // Some tickets are removed, decrease their counts
            for (var inx in oldIds) {
                if (ids.indexOf(inx) === -1) {
                    if (_PASSTICKETS[inx]) {
                        _PASSTICKETS[inx]--;
                    }
                }
            }
            // Immediately disable or enable the checkboxes in the stage group
            for (var tkid in _PASSTICKETS) {
                var el = d.getElementById("tl1t_" + ids[tkid]);
                if (el) {
                    hasEventTicket = true;
                    if (_PASSTICKETS[tkid] > 0) {
                        if (!$(el).hasClass("local-disabled"))
                            $(el).addClass("local-disabled")
                                    .find(".form-checkbox-ctn").addClass("disabled")
                                    .find(".form-check-input").attr("disabled", "true");
                    } else {
                        if ($(el).hasClass("local-disabled"))
                            $(el).removeClass("local-disabled")
                                    .find(".form-checkbox-ctn").removeClass("disabled")
                                    .find(".form-check-input").attr("disabled", "false");
                    }
                }
            }
            // If the package contains no tickets in the current event then it will
            // not be added or will be removed. Only in Create Event!
            if (!hasEventTicket && createEventForm.length > 0) {
                if (oData.passId.toString() === response.trim()) {
                    $tr = $tb.find("tr[data-pkid='" + oData.passId + "']");
                    var __reposition = function __reposition($row) {
                        if ($row[0]) {
                            $row.find(".table-position p").html($row.find(".table-position p").html() - 1);
                            __reposition($row.next());
                        }
                    }($tr.next());
                    $tr.remove();
                }
            } else {
                // Add package to the list table
                if (oData.passId.toString() === response.trim()) {
                    $tr = $tb.find("tr[data-pkid='" + oData.passId + "']");
                    oData.active = $tr.find(".table-status").attr("data-active-e");
                    oData.activeAll = $tr.find(".table-status").attr("data-active-a");
                    active = oData.active !== "false" && oData.activeAll !== "false";
                    if (oData.activeAll === "false") {
                        stat = -1;
                    } else if (oData.active === "false") {
                        stat = -2;
                    }
                    stock -= parseInt(oData.inventory);
                } else {
                    oData.passId = response.trim();
                    oData.active = active.toString();
                    oData.inventory = 0;
                    $tb.append($tr);
                    $tr.removeAttr("style").removeAttr("class");
                    $tr.attr("data-pkid", oData.passId);
                    $tr.find(".table-position p").html(pos);
                    $tr.find(".table-status")
                            .attr("data-active-e", oData.active)
                            .attr("data-active-a", oData.active);
                }
                $tr.find(".table-package-name").html(oData.passName);
                $tr.find(".table-package-type").html(function () {
                    return $(this).attr("data-type" + oData.passType);
                });
                $tr.find(".table-money p").html(mf);
                $tr.find(".table-quantity p").html(oData.qty + "<span class='table-quantity-left'>(" + stock + ")</span>");
                if (curDate > sellEndDate) {
                    $tr.find(".table-status").attr("data-stat", "2");
                    if (active)
                        stat = 2;
                } else if (stock <= 0) {
                    $tr.find(".table-status").attr("data-stat", "3");
                    if (active)
                        stat = 3;
                } else if (oData.ticketsSoldOut) {
                    $tr.find(".table-status").attr("data-stat", "4");
                    if (active)
                        stat = 4;
                }
                $tr.find(".table-status-colorbar").attr("class", function () {
                    return "table-status-colorbar " + $(this).attr("data-sc" + stat);
                });
                $tr.find(".table-status-text").html(function () {
                    return $(this).attr("data-st" + stat);
                });
                $tr.find(".table-tickets-inner").html(oData.ticketsHTMList);
                
                var ticketIds = oData.ticketIds.split(",");
                var rebates = oData.rebates.split(",");
                var doorRebates = oData.doorRebates.split(",");
                for (var i = 0; i < ticketIds.length; i++) {                    
                    oData["passTicket-" + ticketIds[i]] = {"rebate" : rebates[i], "doorRebate" : doorRebates[i]};
                };
                $tr.find(".xdata").text(JSON.stringify(oData));
            }
            // Trigger this button will clear all inputs and close the form
            $(".add-new-item-btn.package").trigger("click");
            // Refresh list of tickets and event folders
            loadPackageDirectories();
        };

        pageScrlTo(form.parent().offset().top - 100);
        
        ajax(managePackagePath + "?ajax=true" + encodeURI(data), function (response) {
            if (response.trim() !== "fail") {
                _succeed(response.trim());
            } else {
                // Something here
            }
        });
    };

    var startNewPool = function (e, p) {
        if (p)
            return;

        var form = $(".pooling-qty-ctn");
        form.find("input, textarea, select").each(function () {
            var $this = $(this),
                name = $this.attr("name"),
                type = $this.attr("type");

            if (type === "radio" || type === "checkbox") {
                var checked = $this.prop("checked");
                if (name === "passFree") {
                    if ($this.val() === "false" && !checked)
                        $this.trigger("click");
                } else if (name === "passType") {
                    if ($this.val() === "0")
                        $this.trigger("click");
                } else {
                    if (checked)
                        $this.prop("checked", false).triggerHandler("click");
                }
            } else {
                if (name !== "eventId") {
                    $this.val("");
                    if (type !== "hidden") {
                        $this.removeClass("error success");
                        $this.closest(".input-ctn").removeClass("focused");
                    }
                }

            }
        });
    };

    var startNewPrivateLink = function (e, p) {
        if (p)
            return;

        var form = $(".create-private-link-form"),
            cd = $("#systemCurrentDate").val() ;
        form.find(".create-private-link-btn").text(function () {
            return $(this).attr("data-label");
        });
        var eventId;
        form.find("input, textarea, select").each(function () {
            var $this = $(this),
                name = $this.attr("name"),
                type = $this.attr("type");

            if (type === "radio" || type === "checkbox") {
                var checked = $this.prop("checked");
                if (name === "passFree") {
                    if ($this.val() === "false" && !checked)
                        $this.trigger("click");
                } else if (name === "passType") {
                    if ($this.val() === "0")
                        $this.trigger("click");
                } else {
                    if (checked)
                        $this.prop("checked", false).triggerHandler("click");
                }
            } else {
                if (name !== "eventId") {
                    $this.val("");
                    if (type !== "hidden") {
                        $this.removeClass("error success");
                        $this.closest(".input-ctn").removeClass("focused");
                    }
                }else{
                    eventId=$this.val();
                }
                if(name==="url"){
                    $this.prop("readonly",false);
                }
            }
        });

        form.find(".package-multiple-choice-number-input-ctn").removeClass("disabled disabled-ctn")
            .find(".form-input").removeClass("disabled").removeAttr("disabled");

        form.find(".associate-private-link-tickets-boxes-outer-ctn").removeClass("soldlocked");
        form.find(".associate-private-link-tickets-box").show();
        form.find(".tickets-list-one-ticket-ctn.selected").each(function () {
            $(this).find(".handler .svg-x").click();
        });
        loadPrivateDirectories(createEventForm.find("[name='id']").val());
    };

    var startNewPackage = function (e, p) {
        if (p)
            return;

        var form = $(".create-package-form"),
                cd = $("#systemCurrentDate").val(),
                ct = roundTime($("#systemCurrentTime").val());

        cd = cd.substr(0, 4) + "/" + cd.substr(4, 2) + "/" + cd.substr(6, 2);

        // Set isAPass checkbox
        var isAPassCheckbox = form.find("[name='isAPass']");
        isAPassCheckbox.prop("disabled", false);
        
        form.find(".create-package-btn").text(function () {
            return $(this).attr("data-label");
        });
        form.find("input, textarea, select").each(function () {
            var $this = $(this),
                    name = $this.attr("name"),
                    type = $this.attr("type");

            if (type === "radio" || type === "checkbox") {
                var checked = $this.prop("checked");
                if (name === "passFree") {
                    if ($this.val() === "false" && !checked)
                        $this.trigger("click");
                } else if (name === "passType") {
                    if ($this.val() === "0")
                        $this.trigger("click");
                } else {
                    if (checked)
                        $this.prop("checked", false).triggerHandler("click");
                }
            } else {
                if (name !== "eventId") {
                    $this.val("");
                    if (type !== "hidden") {
                        $this.removeClass("error success");
                        $this.closest(".input-ctn").removeClass("focused");
                    }
                }
            }
        });
        form.find(".package-standard-choice, .package-multiple-choice").show();
        form.find(".package-multiple-choice-number-input-ctn").removeClass("disabled disabled-ctn")
            .find(".form-input").removeClass("disabled").removeAttr("disabled");
        form.find(".ticket-form-info-quantity-sold, .ticket-form-info-quantity-remain").text("0");
        form.find(".ticket-price-outer-ctn").show();
        form.find(".soldisabled").hide();
        form.find(".associate-package-tickets-boxes-outer-ctn").removeClass("soldlocked");
        form.find(".associate-package-tickets-box").show();
        triggerInputFocus("#passStart-date-4", cd, "change");
        triggerInputFocus("#passStart-time-4", ct, "change");
        form.find(".tickets-list-one-ticket-ctn.selected").each(function () {
            $(this).find(".handler .svg-x").click();
        });
    };

    var modifyPackage = function (e) {
        var btn = $(this),
                item = btn.closest("td"),
                form = $(".create-package-form"),
                xdata = jsonEscape(item.find(".xdata").text()),
                oData = JSON.parse(xdata),
                idList = oData.ticketIds.split(","),
                leftBox = form.find(".associate-package-tickets-box.left"),
                rightBox = form.find(".associate-package-tickets-box.right");

        var isAPassCheckbox = form.find("[name='isAPass']");
        isAPassCheckbox.prop("checked", oData.isAPass === "true" || oData.isAPass === true);
        isAPassCheckbox.prop("disabled", true);
        
        if (item.closest("table").hasClass("packages-archive-table")) {
            return false;
        }
        pageScrlTo(form.parent().offset().top);

        if (!form.hasClass("open")) {
            $(".add-new-item-btn.package").trigger("click", {type: "modify"});
        }
        $(".create-package-btn", form).text(function () {
            return $(this).attr("data-label2");
        });

        for (var name in oData) {
            var el = form.find("[name='" + name + "']");
            if (name.substr(name.length - 4) === "Date") {
                el = form.find(".datepicker[name='" + name.substring(0, name.length - 4) + "']");
            } else if (name.substr(name.length - 4) === "Time") {
                el = form.find(".timepicker[name='" + name.substring(0, name.length - 4) + "']");
                oData[name] = oData[name].replace("h", ":");
            }
            if (el.length > 0) {
                var type = el.attr("type");
                var value = oData[name];

                if (type === "radio") {
                    el.each(function () {
                        if ($(this).val() === value) {
                            $(this).prop("checked", true).triggerHandler("change");
                        }
                    });
                } else if (type === "checkbox") {
                    if (el.prop("checked") !== (el.val() === value)) {
                        el.trigger("click").triggerHandler("change");
                    }
                } else {
                    el.val(value);
                    if (type !== "hidden") {
                        el.triggerHandler("blur");
                        triggerInputFocus(el);
                    }
                }
            }
            if (name === "passFree") {
                if (value && value.toString() === "true") {
                    form.find(".soldisabled-pay .ticket-price-online-choice").prop("checked", false);
                    form.find(".soldisabled-free .ticket-price-online-choice").prop("checked", true).triggerHandler("change");
                } else {
                    form.find(".soldisabled-free .ticket-price-online-choice").prop("checked", false);
                    form.find(".soldisabled-pay .ticket-price-online-choice").prop("checked", true).triggerHandler("change");
                }
            } else if (name === "passDoorPriceActivated") {
                form.find(".soldisabled .ticket-price-door-choice").prop("checked", (value && value.toString() === "true")).triggerHandler("click change");
            }
        }
        // Prevent price change and association if a bundle was bought
        if (parseInt(oData.qtySold) > 0 || parseInt(oData.inventory) > 0) {
            form.find(".associate-package-tickets-boxes-outer-ctn").addClass("soldlocked");
            leftBox.hide();
            form.find(".ticket-price-outer-ctn").hide();
            form.find(".soldisabled").css("display", "flex");
            if (oData.passFree === "false") {
                form.find(".soldisabled-pay").css("display", "");
                form.find(".soldisabled-free").hide();
                form.find(".soldisabled .ticket-price-input-raw").val(oData.passPrice);
                form.find(".soldisabled .ticket-price-input-fee").val(oData.passFees);
                form.find(".soldisabled .ticket-price-input-final").val(oData.passFinalPrice);
            } else {
                form.find(".soldisabled-pay").hide();
                form.find(".soldisabled-free").css("display", "");
            }
            if (oData.passDoorPriceActivated === "true") {
                form.find(".soldisabled-door").css("display", "");
                form.find(".tickets-doors-price-info").show();
                form.find(".tickets-price-box-door").show();
                form.find(".soldisabled input[name = 'doorPrice']").val(oData.doorPrice);
                form.find(".soldisabled input[name = 'doorFees']").val(oData.doorFees);
                form.find(".soldisabled input[name = 'doorFinalPrice']").val(oData.doorFinalPrice);
            } else {
                form.find(".soldisabled-door").hide();
                form.find(".tickets-doors-price-info").hide();
                form.find(".tickets-price-box-door").hide();
            }
            if (oData.passType === "1") {
                form.find(".package-standard-choice").hide();
                form.find(".package-multiple-choice").show();
                form.find(".package-multiple-choice-number-input-ctn").addClass("disabled disabled-ctn")
                    .find(".form-input").addClass("disabled").attr("disabled", "true");
            } else {
                form.find(".package-standard-choice").show();
                form.find(".package-multiple-choice").hide();
                form.find(".package-multiple-choice-number-input-ctn").removeClass("disabled disabled-ctn")
                    .find(".form-input").removeClass("disabled").removeAttr("disabled");
            }
        } else {
            form.find(".associate-package-tickets-boxes-outer-ctn").removeClass("soldlocked");
            leftBox.show();
            form.find(".ticket-price-outer-ctn").css("display", "");
            form.find(".soldisabled").hide();
            form.find(".package-standard-choice, .package-multiple-choice").show();
            form.find(".package-multiple-choice-number-input-ctn").removeClass("disabled disabled-ctn")
                .find(".form-input").removeClass("disabled").removeAttr("disabled");
        }
        form.find(".ticket-form-info-quantity-sold").text(oData.inventory);
        form.find(".ticket-form-info-quantity-remain").text(parseInt(oData.qty) - parseInt(oData.inventory));
        // Clear the ticket list from the previous modification
        rightBox.find(".selected").each(function () {
            removeTicketFromPackage.call(this, {data: leftBox});
        });
        // Display the selected tickets using the ids
        for (var i = 0; i < idList.length; i++) {
            try {
                var ticketInfos = oData["passTicket-" + idList[i]];
                addTicketToPackage(null, rightBox[0], leftBox.find(".tickets-list-one-ticket-ctn[data-id='P1" + idList[i] + "']"), ticketInfos);
            } catch (err) {
            }
        }
    };

    var statusPrivateLink = function (e) {
        var btn = $(this),
            item = btn.closest("td"),
            xdata = jsonEscape(item.find(".xdata").text()),
            data = "",
            oData = JSON.parse(xdata),
            sus = "suspend-sale-btn",
            act = "activate-sale-btn";

            data += "&privateLinkId="+oData.privateLinkId;
            data += "&eventId="+oData.eventId;
            data += "&active=" + (oData.active==="true"?"false":"true");

        var _succeed = function (response) {
            var $tb = $(".event-form-private-link-table>tbody"),
                $tr = $tb.find("tr:eq(0)").clone(true, true),
                rws=$(".event-form-private-link-table>tbody>tr").length-1;
            if (oData.privateLinkId.toString() === response.trim()) {
                oData.active=(oData.active==="true"?"false":"true");
                if( oData.active==="true"){
                    btn.addClass(sus).removeClass(act);
                }else{
                    btn.addClass(act).removeClass(sus);
                }
                $tr = $tb.find("tr[data-pkid='" + oData.privateLinkId + "']");
                // //  $tr.find(".table-private-id").html(oData.privateLinkId);
                // $tr.find(".table-private-internal-name").html(oData.internalName);
                // $tr.find(".table-private-subtitle").html(oData.subtitle);
                // $tr.find(".table-private-url").html(oData.url);
                // $tr.find(".table-tickets-inner").html(oData.ticketsHTMList);
                $tr.find(".table-status-text").html(oData.active==="true"?"Active":"Inactive");
                $tr.find(".table-status-colorbar").attr("class", "table-status-colorbar " + (oData.active==="true"?"blue":"red"));
                $tr.find(".xdata").text(JSON.stringify(oData));
            }
        };

        ajax(managePrivateLinksPath + "?ajax=true&statusUpdate=true" + encodeURI(data), function (response) {
            if (response.trim() !== "fail") {
                _succeed(response.trim());
            } else {
                // Something here
            }
        });

    };

    var modifyPrivateLink = function (e) {
        var btn = $(this),
                item = btn.closest("td"),
                form = $(".create-private-link-form"),
                xdata = jsonEscape(item.find(".xdata").text()),
                oData = JSON.parse(xdata),
                idList = oData.ticketIds.split(","),
                leftBox = form.find(".associate-private-link-tickets-box.left"),
                rightBox = form.find(".associate-private-link-tickets-box.right");

        if (item.closest("table").hasClass("packages-archive-table")) {
            return false;
        }

        form.find(".form-private-link-id").val(oData.id);
        pageScrlTo(form.parent().offset().top);

        if (!form.hasClass("open")) {
            $(".add-new-item-btn.private").trigger("click", {type: "modify"});
        }
        $(".create-private-link-btn", form).text(function () {
            return $(this).attr("data-label2");
        });

        for (var name in oData) {
            var el = form.find("[name='" + name + "']");
            if (el.length > 0) {
                var type = el.attr("type");
                var value = oData[name];

                if (type === "radio") {
                    el.each(function () {
                        if ($(this).val() === value) {
                            $(this).prop("checked", true).triggerHandler("change");
                        }
                    });
                } else if (type === "checkbox") {
                    if (el.prop("checked") !== (el.val() === value)) {
                        el.trigger("click").triggerHandler("change");
                    }
                } else {
                    el.val(value);
                    if (type !== "hidden") {
                        el.triggerHandler("blur");
                        triggerInputFocus(el);
                    }
                }

                if(name==="url"){
                    el.prop("readonly", true);
                }
            }
        }

        rightBox.find(".selected").each(function () {
            removeTicketFromPrivateLink.call(this, {data: leftBox});
        });
        // Display the selected tickets using the ids
        for (var i = 0; i < idList.length; i++) {
            try {
                var ticketInfos = oData["passTicket-" + idList[i]];
                addTicketToPrivateLink(null, rightBox[0], leftBox.find(".private-tickets-list-one-ticket-ctn[data-id='P1" + idList[i] + "']"), ticketInfos);
            } catch (err) {
            }
        }
    };

    var togglePackageVisibility = function (e) {
        var btn = $(this),
                item = btn.closest("tr"),
                qeid = "&eventId=" + item.data("evid"),
                qpid = "&passId=" + item.data("pkid"),
                elCell = item.find(".table-status"),
                elColor = item.find(".table-status-colorbar"),
                elText = item.find(".table-status-text"),
                sus = "suspend-sale-btn",
                act = "activate-sale-btn";

        if (item.closest("table").hasClass("packages-archive-table")) {
            return false;
        }
        if (btn.hasClass(sus)) {
            ajax(managePackagePath + "?ajax=true&hideFromEvent=false" + qeid + qpid, function (response) {
                if (response.trim() !== "0" && response.trim() !== "fail") {
                    btn.addClass(act).removeClass(sus);
                    elCell.attr("data-active-e", "false");
                    elCell.attr("data-stat", "4");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc-2"));
                    elText.html(elText.attr("data-st-2"));
                }
            });
        } else {
            ajax(managePackagePath + "?ajax=true&hideFromEvent=true" + qeid + qpid, function (response) {
                if (response.trim() !== "0" && response.trim() !== "fail") {
                    btn.addClass(sus).removeClass(act);
                    elCell.attr("data-active-e", "true");
                    var stat = elCell.attr("data-active-a") === "false" ? "-1" : elCell.attr("data-stat");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc" + stat));
                    elText.html(elText.attr("data-st" + stat));
                }
            });
        }
    };

    var togglePackageSale = function (e) {
        var btn = $(this),
                item = btn.closest("tr"),
                qpid = "&passId=" + item.data("pkid"),
                elCell = item.find(".table-status"),
                elColor = item.find(".table-status-colorbar"),
                elText = item.find(".table-status-text"),
                sus = "suspend-sale-btn",
                act = "activate-sale-btn";

        if (item.closest("table").hasClass("packages-archive-table")) {
            return false;
        }
        if (btn.hasClass(sus)) {
            ajax(managePackagePath + "?ajax=true&active=false" + qpid, function (response) {
                if (response.trim() !== "0" && response.trim() !== "fail") {
                    btn.addClass(act).removeClass(sus);
                    elCell.attr("data-active-a", "false");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc-1"));
                    elText.html(elText.attr("data-st-1"));
                }
            });
        } else {
            ajax(managePackagePath + "?ajax=true&active=true" + qpid, function (response) {
                if (response.trim() !== "0" && response.trim() !== "fail") {
                    btn.addClass(sus).removeClass(act);
                    elCell.attr("data-active-a", "true");
                    var stat = elCell.attr("data-active-e") === "false" ? "-2" : elCell.attr("data-stat");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc" + stat));
                    elText.html(elText.attr("data-st" + stat));
                }
            });
        }
    };

    var duplicatePackage = function (e) {
        var item = $(this).closest("tr"),
                id = item.attr("data-pkid");

        if (item.closest("table").hasClass("packages-archive-table")) {
            return false;
        }
        ajax(managePackagePath + "?ajax=true&duplicate=true&passId=" + id, function (response) {
            if (response.trim() !== "fail") {
                var newId = response.substring(0, response.indexOf("-")),
                        clone = item.clone(true, true),
                        colStat = clone.find(".table-status"),
                        oData = {};

                clone.appendTo(item.parent());
                clone.attr("data-pkid", newId);
                // Check if the bundle's sale was out-of-stock then restock it as
                // this cloned bundle is new, the stock is restored. Default status is 1
                if (colStat.attr("data-stat") === "3") {
                    colStat.attr("data-stat", "1");
                    colStat.find(".table-status-colorbar").attr("class", "table-status-colorbar " + colStat.find(".table-status-colorbar").attr("data-sc1"));
                    colStat.find(".table-status-text").html(colStat.find(".table-status-text").attr("data-st1"));
                }
                clone.find(".table-quantity-left").html(clone.find(".table-quantity p")[0].childNodes[0].textContent);
                try {
                    oData = JSON.parse(jsonEscape(clone.find(".xdata").text()));
                } catch (err) {
                }
                // In case of error, skip data change
                // Assign new id and inventory in the data
                if (oData.passId) {
                    oData.passId = newId;
                    oData.inventory = 0;
                    clone.find(".xdata").text(JSON.stringify(oData));
                }
            } else {
                // Duplicate error
            }
        }, true);
    };

    var toggleArchivePackage = function (e) {
        var btn = $(this),
                item = btn.closest("tr"),
                qpid = "&passId=" + item.data("pkid"),
                elCell = item.find(".table-status"),
                elColor = item.find(".table-status-colorbar"),
                elText = item.find(".table-status-text"),
                sus = "suspend-sale-btn",
                act = "activate-sale-btn";

        if (btn.hasClass(sus)) {
            ajax(managePackagePath + "?ajax=true&archive=true" + qpid, function (response) {
                if (response.trim() !== "fail") {
                    if (response.trim().split("-")[1] !== "true") {
                        return false;
                    }
                    btn.addClass(act).removeClass(sus);
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc-3"));
                    elText.html(elText.attr("data-st-3"));
                    item.appendTo($(".packages-archive-table>tbody"));
                }
            });
        } else {
            ajax(managePackagePath + "?ajax=true&archive=false" + qpid, function (response) {
                if (response.trim() !== "fail") {
                    if (response.trim().split("-")[1] !== "false") {
                        return false;
                    }
                    btn.addClass(sus).removeClass(act);
                    var stat = elCell.attr("data-active-a") === "false" ? "-1" : elCell.attr("data-stat");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc" + stat));
                    elText.html(elText.attr("data-st" + stat));
                    item.appendTo($(".event-form-packages-table:not(.packages-archive-table)>tbody"));
                }
            });
        }
    };

    var displayPackageArchives = function (e) {
        var btn = $(this);
        if (!btn.hasClass("animing")) {
            btn.toggleClass("open animing");
            $(".packages-archive-table-ctn").slideToggle(300, function () {
                btn.removeClass("animing");
            });
        }
    };

    var displayPackageNumberInput = function (e) {
        if (this.checked) {
            var targ = $(this).closest(".package-type-choices-ctn").find(".package-multiple-choice-number");
            if (this.value === "1") {
                targ.removeClass("hide")
                        .find(".input").addClass("required");
                $(".package-minimum-tickets-amount-ctn").removeClass("hide");

                calculatePackagePrice();
                calculatePackageDoorPrice();
            } else {
                targ.addClass("hide")
                        .find(".input").removeClass("required");
                $(".package-minimum-tickets-amount-ctn").addClass("hide");
            }
        }
    };

    var changePackageMinTickets = function (e) {
        var val = parseInt(this.value) || 1;
        if (val < 1)
            val = 1;

        var inp = this;
        setTimeout(function () {
            inp.value = val;
            d.querySelector(".package-minimum-tickets-amount-ctn .number").innerHTML = val;
        }, 60);
        calculatePackagePrice();
        calculatePackageDoorPrice();
    };

    var confirmDeletePackage = function (e) {
        e.stopImmediatePropagation();
        var item = e.data.item;
        var pkid = item.attr("data-pkid");
        var xdata = jsonEscape(item.find(".xdata").eq(0).text());
        var oData = JSON.parse(xdata);
        var ticketIds = oData.ticketIds;

        ajax(managePackagePath + "?ajax=true&delete=true&passId=" + pkid, function (response) {
            if (response.trim() === "success") {
                item.remove();
                if ($(".form-package-id").val() === pkid) {
                    $(".create-package-form .close-toggle-form-btn").click();
                }
                // Release the bound tickets
                for (var tkid in _PASSTICKETS) {
                    var el = d.getElementById("tl1t_" + ticketIds[tkid]);
                    if (el && _PASSTICKETS[tkid] <= 0 && $(el).hasClass("local-disabled")) {
                        $(el).removeClass("local-disabled")
                                .find(".form-checkbox-ctn").removeClass("disabled")
                                .find(".form-check-input").attr("disabled", "false");
                    }
                }
            }
        });
        closeWindow("deletePackageConfirmPopup");
    };

    var deletePackage = function (e) {
        var btnYes = $("#deletePackageConfirmPopup .popup-btn-confirm"),
                btnNo = $("#deletePackageConfirmPopup .popup-btn-cancel");

        btnYes.one("click", {item: $(this).closest("tr")}, confirmDeletePackage);
        btnNo.one("click", function (e) {
            btnYes.off("click", confirmDeletePackage);
            closeWindow("deletePackageConfirmPopup");
        });
        $("#deletePackageConfirmPopup").css("position", "absolute");
        openWindow("deletePackageConfirmPopup", true);
    };

    var deletePrivateLink = function (e) {
        var btnYes = $("#deletePrivateLinkConfirmPopup .popup-btn-confirm"),
                btnNo = $("#deletePrivateLinkConfirmPopup .popup-btn-cancel");

        btnYes.one("click", {item: $(this).closest("tr")}, confirmDeletePrivateLink);
        btnNo.one("click", function (e) {
            btnYes.off("click", confirmDeletePrivateLink);
            closeWindow("deletePrivateLinkConfirmPopup");
        });
        $("#deletePrivateLinkConfirmPopup").css("position", "absolute");
        openWindow("deletePrivateLinkConfirmPopup", true);
    };

    var confirmDeletePrivateLink = function (e) {
        e.stopImmediatePropagation();
        var item = e.data.item;
        var pkid = item.attr("data-pkid");
        var evid = item.attr("data-evid");
        var xdata = jsonEscape(item.find(".xdata").eq(0).text());
        var oData = JSON.parse(xdata);
        var ticketIds = oData.ticketIds;

        ajax(managePrivateLinksPath + "?ajax=true&delete=true&privateLinkId=" + pkid+"&eventId=" + evid, function (response) {
            if (response.trim() === "success") {
                item.remove();
                if ($(".form-private-link-id").val() === pkid) {
                    $(".create-private-link-form .close-toggle-form-btn").click();
                }
                for (var tkid in _PASSTICKETS) {
                    var el = d.getElementById("tl1t_" + ticketIds[tkid]);
                    if (el && _PASSTICKETS[tkid] <= 0 && $(el).hasClass("local-disabled")) {
                        $(el).removeClass("local-disabled")
                            .find(".form-checkbox-ctn").removeClass("disabled")
                            .find(".form-check-input").attr("disabled", "false");
                    }
                }
            }
        });
        closeWindow("deletePrivateLinkConfirmPopup");
    };

    var deletePool= function (e) {
        var btnYes = $("#deletePoolConfirmPopup .popup-btn-confirm"),
            btnNo = $("#deletePoolConfirmPopup .popup-btn-cancel");

        btnYes.one("click", {item: $(this).closest("tr")}, confirmDeletePool);
        btnNo.one("click", function (e) {
            btnYes.off("click", confirmDeletePool);
            closeWindow("deletePoolConfirmPopup");
        });
        $("#deletePoolConfirmPopup").css("position", "absolute");
        openWindow("deletePoolConfirmPopup", true);
    };

    var confirmDeletePool= function (e) {
        e.stopImmediatePropagation();
        var item = e.data.item;
        var pqid = item.attr("data-pqid");
        var evid = item.attr("data-evid");
        var xdata = jsonEscape(item.find(".xdata").eq(0).text());

        ajax(managePoolsPath + "?ajax=true&delete=true&poolId=" + pqid+"&eventId=" + evid, function (response) {
            if (response.trim().includes("fail")) {
                if(response.trim().includes("deletePoolVialate")){
                    if (lang === "fr") {
                        alert("Des billets sont associés à ce groupe de billets. Vous devez retirer les billets de ce groupe avant de pouvoir le supprimer.");
                    } else {
                        alert("Tickets are already assigned to this pool. Please remove the tickets from this pool before deleting it.");
                    }
                }
            }else if (response.trim() === "success") {
                item.remove();
                if ($(".poolId").val() === pqid) {
                    $(".create-pool-form .close-toggle-form-btn").click();
                }
            }
        });
        closeWindow("deletePoolConfirmPopup");
    };


    var handleServiceFee = function (event) {
        var t = $(this);

        if (t.hasClass('fee-per-transaction')) {
            $('.transaction-service-fee-ctn').slideToggle();
            $('.transaction-service-fee').toggleClass('required');
            $('.fee-per-ticket-ctn').toggleClass('disabled');
        } else {
            $('.fee-per-transaction-ctn').toggleClass('disabled');
            $('.ticket-service-fee-ctn').toggleClass('hide');
            $('.ticket-price-outer-ctn:not(.soldisabled) .ticket-price-input-service-fee').toggleClass('required');
            if (!t.is(":checked")) {
                $('.ticket-price-input-service-fee').val(0);
                $(".ticket-price-outer-ctn").each(function (e) {
                    calcTicketPriceFinal(e, $(this).find(".ticket-price-input-raw"));
                });
                $(".event-form-tickets-table .table-money").each(function () {
                    var t = $(this);
                    var ser = t.attr("data-service");
                    if (ser !== null && ser !== undefined) {
                        var price = t.attr("data-price");
                        var fPrice = Number.parseFloat(price) - Number.parseFloat(ser);
                        t.find("p").text(formatMoney((fPrice)));
                        t.attr("data-price", fPrice);
                    }
                });
            } else {
                $(".event-form-tickets-table .table-money").each(function () {
                    var t = $(this);
                    var ser = t.attr("data-service");
                    if (ser !== null && ser !== undefined) {
                        var price = t.attr("data-price");
                        var fPrice = Number.parseFloat(price) + Number.parseFloat(ser);
                        t.find("p").text(formatMoney((fPrice)));
                        t.attr("data-price", fPrice);
                    }
                });
                if ($(".toggle-form-ctn.open").length !== 0 && $("#ticketFormTkId").attr("value") !== null && $("#ticketFormTkId").attr("value") !== undefined) {
                    var sf = $(".event-form-tickets-table").find("tr[data-tkid = " + $("#ticketFormTkId").attr("value") + "]").find(".table-money").attr("data-service");
                    if (sf !== null && sf !== undefined) {
                        $('.ticket-price-input-service-fee').val(sf);
                        calcTicketPriceFinal(event, $(".ticket-price-input-raw"));
                    }
                }
            }
        }
    };

    //Event info
    var initStep1 = function () {
        eventAgeSelectInput = $('.event-age-select');
        eventAgeSelectInput.change(checkAgeChoice);
        eventTypeRadioInput = $('.form-check-input[name="ticketType"]');
        eventTypeRadioInput.change(checkEventType);
        nextStepBtn = $('.next-step-event-btn');
        nextStepBtn.click(goToNextStep);
        oneStepCtn = $('.steps-bar-one-step-number-outer-ctn');
        oneStepCtn.click(chooseStep);
        showStepsRespBtn = $('.create-event-choose-step-responsive-btn');
        showStepsRespBtn.click(showSteps);
        createEventBtn = $('.create-event-btn');
        createEventBtn.click(saveEvent);
        $('.popup-event-modified-btn').click(openEventModifiedPopup);
        publishEventBtn = $(".publish-event-btn");
        publishEventBtn.click(publishEvent);
        modifyEventBtn = $(".modify-event-btn");
        modifyEventBtn.click(savePubEvent);
        previewEventBtn = $('.preview-event-btn');
        previewEventBtn.click(previewEvent);
        eventVisibilityChoice = $('.event-visibility-choice');
        eventVisibilityChoice.change(checkVisibilityChoice);
        eventPublicationChoice = $('.event-publication-choice');
        eventPublicationChoice.change(checkPublicationChoice);
        searchProfileInput = $('.search-profile-input');
        searchProfileInput.keyup(searchProfile);
        searchInputAndDropDownCtn = $('.search-input-and-drop-down-ctn');
        searchDropDown = $('.search-drop-down');
        searchDropDownChoiceOuterCtn = $('.search-drop-down-choices-outer-ctn');
        searchDropDownChoiceInnerCtn = $('.search-drop-down-choices-inner-ctn');
        addressInput = $("input[name=locationAddress]");
        cityInput = $("input[name=locationCity]");
        cpInput = $("input[name=locationPC]");
        provInput = $("input[name=locationProvince]");
        countryInput = $("input[name=locationCountry]");
        addNewArtistBtn = $('.add-new-artist-btn');
        addNewArtistBtn.click(addNewProfile);
        addNewLocationBtn = $('.add-new-location-btn');
        addNewLocationBtn.click(addNewProfile);
        profileSelectionBox = $('.box-theme-ctn.profile-selection');
    };

    //Tickets and palier
    var initStep3 = function () {
        $(".fee-per-transaction").change(handleServiceFee);
        $(".fee-per-ticket").change(handleServiceFee);
        $(".add-new-item-btn.ticket").click(startNewTicket);
        $(".manage-levels-btn").click(toggleTicketStageForm);
        $(".ticket-qty-input").change(checkEventCapacity);
        $(".display-on-ticket-check").change(checkToDisplayEventDT);
        $(".ticket-price-online-choice").change(togglePriceBox);
        $(".ticket-price-door-choice").change(togglePriceBox);
        $(".ticket-price-input-raw").change(calcTicketPriceFinal);
        $(".ticket-price-input-service-fee").change(calcTicketPriceFinal);
        $(".ticket-price-input-final").change(calcTicketPriceRaw);
        $(".create-ticket-btn").click(createTicket);
        $(".event-form-tickets-table>tbody").sortable(new sortableOptions("ticket"));
        $(".event-form-tickets-table .table-delete-btn").click(deleteTicket);
        $(".toggle-ticket-sale-btn").click(toggleTicketSale);
        $(".modify-ticket-btn").click(modifyTicket);
        $(".modify-pool-btn").click(modifyPool);
        $(".table-position-arrow-btn.up").click(sortItemUp);
        $(".table-position-arrow-btn.down").click(sortItemDown);
        $(".event-form-pool-table .table-delete-btn").click(deletePool);
        $(".create-pool-btn").click(createPool);
        $(".manage-pooling-qty").click(startNewPool);
        $("#start-date-create-event-one-day").change(["#create-event-door-other-date", "#door-date-create-event-one-day"], setDoorDate);
        $("#customStart-date-multiple-days").change(["#create-ticket-door-other-date", "#customDoorStart-date-multiple-days"], setDoorDate);
        $(".modify-ticket-display-date").click(modifyTicketDisplayEventDate);
        $(".modify-ticket-display-door-time").click(modifyTicketDisplayDoorTime);

        $(".tickets-list-one-ticket-check").change(addOrRemoveStageTicket);
        $(".tickets-stage-table>tbody").sortable(new sortableOptions("stage"));
        $(".tickets-stage-table .table-delete-btn").click(removeStageTicket);
        $(".tickets-stage-save-btn").click(saveStageTicket);

        toggleServiceFeesBtn = $('.manage-service-fee');
        toggleServiceFeesBtn.on("click", toggleServiceFeeAction);
        togglePoolingQtyBtn = $('.ticket-pool-qty');
        togglePoolingQtyBtn.on("click", togglePoolingQtyAction);
        poolingQtySelect = $('.event-pooling-selection-ctn>select');
        poolingQtySelect.on("change", changeEventPool);
        serviceFeesCtn = $(".service-fees-options-ctn");
        poolingQtyCtn = $(".pooling-qty-items-ctn");
    };

    //Package Bundle Forfait
    var initStep4 = function () {
        try {
            $.extend(_PASSTICKETS, PASSTICKETS);
        } catch (err) {
        }

        $(".add-new-item-btn.package").click(startNewPackage);
        $(".create-package-btn").click(createPackage);
        $(".modify-package-btn").click(modifyPackage);
        $(".toggle-package-visible-btn").click(togglePackageVisibility);
        $(".toggle-package-sale-btn").click(togglePackageSale);
        $(".toggle-package-archive-btn").click(toggleArchivePackage);
        $(".duplicate-package-btn").click(duplicatePackage);
        $(".forfaits-archives-btn").click(displayPackageArchives);
        $(".event-form-packages-table").sortable(new sortableOptions("package"));
        $(".package-type-choices-ctn .radio").on("change", displayPackageNumberInput);
        $(".package-multiple-choice-number-input-ctn input").on("change", changePackageMinTickets);
        $(".event-form-packages-table .table-delete-btn").click(deletePackage);
    };

    var initStep6new = function () {
        try {
            $.extend(_PASSTICKETS, PASSTICKETS);
        } catch (err) {
        }

        $(".add-new-item-btn.private").click(startNewPrivateLink);
        $(".create-private-link-btn").click(createPrivateLink);
        $(".modify-private-link-btn").click(modifyPrivateLink);
        $(".status-private-link-btn").click(statusPrivateLink);
        $(".event-form-private-link-table .table-delete-btn").click(deletePrivateLink);
       //  $(".toggle-package-visible-btn").click(togglePackageVisibility);
       //  $(".toggle-package-sale-btn").click(togglePackageSale);
       //  $(".toggle-package-archive-btn").click(toggleArchivePackage);
       //  $(".duplicate-package-btn").click(duplicatePackage);
       //  $(".forfaits-archives-btn").click(displayPackageArchives);
       // $(".event-form-packages-table").sortable(new sortableOptions("package"));
      //  $(".package-type-choices-ctn .radio").on("change", displayPackageNumberInput);
       // $(".package-multiple-choice-number-input-ctn input").on("change", changePackageMinTickets);
       // $(".event-form-packages-table .table-delete-btn").click(deletePackage);
    };

    //Merch
    var initStep5 = function () {
        $(".event-form-products-table>tbody").sortable(new sortableOptions("merch"));
    };

    var toggleSubAction = function () {
        var t = $(this);
        var sub = t.next(".sub-ctn");
        if (t.find("input[type=checkbox]").is(":checked")) {
            sub.slideDown();
        } else {
            sub.slideUp();
        }
    };

    var toggleServiceFeeAction = function () {
        var t = $(this);

        if (t.hasClass("active")) {
            serviceFeesCtn.slideUp();
            t.removeClass("active");
        } else {
            t.addClass("active");
            serviceFeesCtn.slideDown();
        }
    };
    var togglePoolingQtyAction = function () {
        var t = $(this);
        if (!t.prop("checked")) {
            poolingQtyCtn.slideUp();
            poolingQtySelect.removeAttr("required");
            t.removeClass("active");
           // $(".ticket-form-infos-inputs-ctn").find(".ticket-qty-input").prop("readonly",false);
           // $(".ticket-form-infos-inputs-ctn").find(".min-one").prop("readonly",false);
        } else {

            var _succeed = function (response) {
                var poolSelect = $(".event-pooling-selection-ctn>select");
                var json = JSON.parse(response.trim());
                var items="<option value='-1' dt-poolqty='0' dt-usedqty='0'>Select a pool</option>";
                for (var i = 0; i < json.length; i++) {
                    var item=json[i];
                    var selected="";
                    if($(".poolingQtyId").val()==item.poolId){
                        selected="selected";
                        var remain= parseInt(item.poolQty,10)-parseInt(item.usedQty,10);
                        $(".ticket-form-infos-inputs-ctn").find(".ticket-form-info-quantity-remain").text(remain);
                    }
                    items+="<option value='"+item.poolId+"' dt-poolqty='"+item.poolQty+"' dt-usedqty='"+item.usedQty+"' "+selected+">"+item.poolName + " ("+item.usedQty+"/"+item.poolQty+")" +"</option>";
                }
                poolSelect.html(items);
               // $(".ticket-form-infos-inputs-ctn").find(".ticket-qty-input").prop("readonly",true);
               // $(".ticket-form-infos-inputs-ctn").find(".min-one").prop("readonly",true);
            t.addClass("active");
                poolingQtySelect.prop("required",true);
            poolingQtyCtn.slideDown();
        }

            ajax(managePoolsPath + "?ajax=true&list=true&eventId=" + $("#ticketFormEvId").val(), function (response) {
                if (!response.trim().includes("fail")) {
                    _succeed(response.trim());
                } else {
                    alert(response.trim());
                }
            });

        }
    };

    var changeEventPool = function () {
        var t = $(this);
        var option= t.find("option[value='"+t.val()+"']");
        if(option!=null){
          var poolQty= option.attr("dt-poolqty");
          var usedQty= option.attr("dt-usedqty");
         // var remain= $(".ticket-form-infos-inputs-ctn").find(".ticket-form-info-quantity-remain").text();
          if(parseInt(poolQty,10)>0){
             var remain= parseInt(poolQty,10)-parseInt(usedQty,10);
              $(".ticket-form-infos-inputs-ctn").find(".ticket-form-info-quantity-remain").text(remain);
          }
          //$(".ticket-form-infos-inputs-ctn").find(".ticket-qty-input").val(poolQty);
         //  $(".ticket-form-infos-inputs-ctn").find(".min-one").val(parseInt(poolQty,10)-parseInt(usedQty,10));
         // console.log(poolQty +" ," +usedQty);
       }
    }



    var init = function () {
        currPage = $(".page");
        createEventForm = $('.create-event-form');
        editEventId = createEventForm.find('input[name="id"]').val();
        datePickerInput = $('.datepicker');
        datePickerInput.change(getPickerDate);
        timePickerInput = $('.timepicker');
        timePickerInput.change(getPickerTime);
        toggleSubBtn = $('.toggle-sub-ctn');
        toggleSubBtn.on("click", toggleSubAction);

        if (createEventForm.length > 0) {
            initStep1();
            initStep3();
            initStep4();
            initStep5();
            initStep6new();
        } else if (d.getElementById("manage_packages")) {
            loadPackageDirectories();
            loadPrivateDirectories();
            initStep3();
            initStep4();
            initStep5();
            initStep6new();
        }

        if (profileSelectionBox !== undefined) {
            // event profiles selection listeners
            profileSelectionBox.find('.one-profile-selected-ctn').each(function () {
                addSelectedProfileListeners($(this));
            });
        }

        if (searchProfileInput !== undefined) {
            // if focusin another search input on the page: hide drop down, reset input and displayed profiles array
            searchProfileInput.focusin(function () {
                var parent = $(this).closest(searchInputAndDropDownCtn);
                var pageCtn = parent.closest('.page');

                pageCtn.find(searchInputAndDropDownCtn).each(function () {
                    if ($(this) !== parent) {
                        resetSearchProfileInput($(this));
                        emptyDropDown($(this).find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item'));
                    }
                });
            });
        }

        // DATETIME PICKERS INIT AND SETTINGS

        if (createEventForm.hasClass('fr')) {
            $.datetimepicker.setLocale('fr');
        }

        $('.event-datetime-start-and-end-ctn:not(.planification)').each(function () {
            var t = $(this);
            var minDate;

            if (t.closest('.event-form-step-ctn').length) {
                minDate = 0;
            } else {
                minDate = false;
            }

            compareDates($('.datepicker.start-date', t), $('.datepicker.end-date', t), t);

            // distinct inits for each input to enable individual datetimepicker options changes later
            $('.datepicker.start-date', t).datetimepicker({
                timepicker: false,
                format: 'Y/m/d',
                formatDate: 'Y/m/d',
                scrollInput: false,
                minDate: minDate,
                onChangeDateTime: function (dp, input) {
                    changeDateTimepickerRange(dp, input, t, minDate, true);
                }
            });

            var startDateVal = $('.datepicker.start-date', t).val();
            var startDateLimit = new Date(startDateVal.split('/')[0], (startDateVal.split('/')[1] - 1), startDateVal.split('/')[2]);

            $('.datepicker.end-date', t).datetimepicker({
                timepicker: false,
                format: 'Y/m/d',
                formatDate: 'Y/m/d',
                scrollInput: false,
                minDate: t.hasClass('limit-time-range') ? startDateLimit : minDate,
                maxDate: t.hasClass('limit-time-range') ? new Date(startDateLimit.setDate(startDateLimit.getDate() + 1)) : false,
                onChangeDateTime: function (dp, input) {
                    changeDateTimepickerRange(dp, input, t, minDate);
                }
            });

            $('.timepicker.start-time', t).datetimepicker({
                datepicker: false,
                format: 'H:i',
                step: 15,
                scrollInput: true,
                onChangeDateTime: function (dp, input) {
                    changeDateTimepickerRange(dp, input, t, null, true);
                }
            });

            $('.timepicker.end-time', t).datetimepicker({
                datepicker: false,
                format: 'H:i',
                step: 15,
                scrollInput: true,
                onChangeDateTime: function (dp, input) {
                    changeDateTimepickerRange(dp, input, t);
                }
            });

            checkLimitTimeRange(t, $('.timepicker.start-time', t));
            checkLimitTimeRange(t, $('.timepicker.end-time', t));
        });

        // disable past dates and time for planned events
        $('.event-datetime-start-and-end-ctn.planification').each(function () {
            var t = $(this);

            $('.datepicker', t).datetimepicker({
                timepicker: false,
                format: 'Y/m/d',
                scrollInput: false,
                minDate: 0,
                onChangeDateTime: function (dp, input) {
                    var today = new Date();
                    var dateChoice = input.datetimepicker('getValue');

                    if (dateChoice !== ('' || null)) {
                        if (today.getFullYear() === dateChoice.getFullYear() && today.getMonth() === dateChoice.getMonth() && today.getDate() === dateChoice.getDate()) {
                            $('.timepicker', t).datetimepicker('setOptions', {
                                minTime: 0
                            });
                        } else if (today.getFullYear() !== dateChoice.getFullYear() || today.getMonth() !== dateChoice.getMonth() || today.getDate() !== dateChoice.getDate()) {
                            $('.timepicker', t).datetimepicker('setOptions', {
                                minTime: false
                            });
                        }
                    }
                }
            });

            $('.timepicker', t).datetimepicker({
                datepicker: false,
                format: 'H:i',
                step: 15,
                scrollInput: false,
                minTime: 0
            });
        });

        // individual pickers
        $('.single-picker .datepicker').datetimepicker({
            timepicker: false,
            format: 'Y/m/d',
            scrollInput: false
        });

        $('.single-picker .timepicker').datetimepicker({
            datepicker: false,
            format: 'H:i',
            step: 15,
            scrollInput: false
        });
        
        //When price at door activated for pass : display door rebate input for each ticket
        $(".ticket-price-door-choice[name = 'passDoorPriceActivated']").on("change", activatePassRebateTicket);
        //When free online price activated for pass : hide rebate input for each ticket
        $(".ticket-price-online-choice[name = 'passFree']").on("click", toggleOnlineRebate);

        if ($('.create-event-form').length > 0) {
            $(window).bind('beforeunload', function () {
                return true;
            });
        }
    };

    $(g).on("load", init);

})(jQuery, document, window);